import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef, SecurityContext, OnDestroy, NgZone, ChangeDetectorRef } from '@angular/core';
import { ColDef, GridApi, GridOptions, RowDataUpdatedEvent } from 'ag-grid-community';
import { AgGridHelperService } from 'src/app/reusables/services/ag-grid-helper.service';
import { FilterValue, MetricComponent, MetricDefinition, NumericType } from 'src/shared/models/pipeline-config/metric-definition.models';
import { CxoneManageMetricsService, GroupAssignment, GroupTypes, MetricDefinitionValidation, SaveMetricResponse, Permissions } from './cxone-manage-metrics.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { NgbModal, NgbModalRef, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { ContextMenuCellRendererComponent } from './context-menu-cell-renderer/context-menu-cell-renderer.component';
import { AssociatedMetricsComponent } from './associated-metrics/associated-metrics.component';
import { ToastrManager } from '@niceltd/cxone-components/toastr';
import { AggregationType, TimeFormat, MetricTypes, ComparisonType } from '../../../../shared/models/pipeline-config/mongo-enums.model';
import { GroupType } from 'src/AngularJS/Models/group-type.model';
import { CxoneMetricNameCellRendererComponent } from './ag-grid-components/cxone-metric-name-cell-renderer/cxone-metric-name-cell-renderer.component';
import { ReportingSetDefinition } from 'src/shared/models/pipeline-config/reporting-sets.models';
import { cloneDeep } from 'lodash';
import { MessageModalComponent } from '@niceltd/cxone-components/modal';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CvCxAssignToolDTO, CvCxAssignToolOptions, CvCxEntities } from 'src/app/reusables/assign-tool/cv-cxone-assign-tool/cv-cxone-assign-tool.models';
import { CvCxoneAssignToolComponent } from 'src/app/reusables/assign-tool/cv-cxone-assign-tool/cv-cxone-assign-tool.component';
import { first } from 'rxjs/operators';
import { GroupDTO } from 'src/app/reusables/assign-tool/angular-assign-tool/angular-assign-tool.models';
import { FilterFieldsEditComponent } from './filter-fields-edit/filter-fields-edit.component';
import { ApiResponse } from 'src/AngularJS/Models/api-response.model';
import tinymce from 'tinymce';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { start } from 'repl';
import { DomSanitizer } from '@angular/platform-browser';
import { data } from 'jquery';
import { MetricSelectorService } from 'src/app/reusables/metric-selector/metric-selector.service';
import { MetricSelectorComponent } from 'src/app/reusables/metric-selector/metric-selector.component';
import { CxoneEtlDataRecalculationService } from '../cxone-etl-recalculation/cxone-etl-data-recalculation/cxone-etl-data-recalculation.service';
import { ManageMetricsRecalculationModalComponent } from './manage-metrics-recalculation-modal/manage-metrics-recalculation-modal.component';
import { LockIconCellRendererComponent } from './ag-grid-components/lock-icon-cell-renderer.component';
import { ManageMetricsRecalculationDetailsModalComponent } from './manage-metrics-recalculation-details-modal/manage-metrics-recalculation-details-modal.component';
import moment from 'moment';
import { CxoneColumnHeaderRendererComponent } from './ag-grid-components/cxone-column-header-renderer/cxone-column-header-renderer.component';
import { InlineNotificationModule } from '@niceltd/sol/inline-notification';
import { AgGridAngular } from 'ag-grid-angular';

interface SelectedCategoryModel {
    name: string;
}

interface SelectedValueModel {
    name: string;
    value: number;
}

interface SelectedValueStringModel {
    name: string;
    value: string;
}


interface MetricValidationFlags {
    nameExists: boolean; //does name have a non empty string value
    nameUnique: boolean; //does not duplicate existing metric
    nameLength: boolean; //name 30 chars or less
    nameChars: boolean; //does not contain unsupported characters +-/*<>=^:()
    category: boolean;
    aggregation: boolean;
    format: boolean;
    direction: boolean;
    description: boolean;
    reportingSet: boolean;
    metricDate: boolean;
    metricEndDate: boolean;
    metricDataValue: boolean;
    formulaInvalid: boolean;
    formulaEmpty: boolean;
    formulaOperator: boolean;
    formulaInvalidMetric: boolean;
    formulaSpecialCharacter: boolean;
    formulaMissingMetric: boolean;
    displayCalculatedErrorMessage: boolean;
    aggregationChanged: boolean;
    formatTypeChanged: boolean;
    metricDateChanged: boolean;
    addFiltersChanged: boolean;
    metricDataValueChanged: boolean;
    metricEndDateChanged: boolean;
    metricNameChanged: boolean;
    rootMetricBeingUsedInFormula: boolean;
    templatePlaceholder: boolean;
}

interface SelectedValueStringModel {
    name: string;
    value: string;
}

interface bracketPair {
    bracket: string;
    index: number;
}

interface modalDetails {
    initiatedBy: string;
    lastModified: string;
    recalculationDate: string;
    def: string;
    recalcComplete: boolean;
}

type MetricValue = "Data field" | "Time" | "Count";

@Component({
    selector: 'cv-cxone-manage-metrics',
    templateUrl: './cxone-manage-metrics.component.html',
    styleUrls: ['./cxone-manage-metrics.component.scss'],
    providers: [DialogService]
})
export class CxoneManageMetricsComponent implements OnInit, OnDestroy {
    @ViewChild('cxoneManageMetricsGrid') agGrid: AgGridAngular;
    @ViewChild('cxoneManageMetricsAssignmentsGrid') agGridAssignments: AgGridAngular;
    public radioUpLabel: string = "Up";
    public radioDownLabel: string = "Down";

    public permissions: Permissions;
    public hasPMLicense: boolean = null;

    public searchValue: string = "";
    public groupTypes: GroupTypes = null;   //previously { emp: [], rec: [] }
    public curMetricCount: number = 0;
    public gridOptions: GridOptions = null;
    public metricDefinitionsData: MetricDefinition[] = [];
    public assocMetricList: MetricDefinition[] = [];
    public localization: Map<string, string>;
    public localizationCommon: Map<string, string>;
    public localizationDescriptions: Map<string, string>;
    public modalRef: NgbModalRef;
    public popOver: NgbPopover;
    public selectedMetric: MetricDefinition;

    public selectedEmpValue: GroupType = null;
    public selectedRecValue: GroupType = null;
    public showDetailView: boolean = false;
    public showCreateView: boolean = false;
    public selectedMetricRow: MetricDefinition = null;
    public origSelectedMetricRow: MetricDefinition = null;
    public selectedRadioValue: string = "0";
    public selectedCategoryValue: SelectedCategoryModel = null;
    public categoryOptions: SelectedCategoryModel[] = [];
    public selectedAggregationValue: SelectedValueModel = null;
    public aggregationOptions: SelectedValueModel[] = [];
    public selectedFormatValue: SelectedValueModel = null;
    public selectedTimeValue: SelectedValueModel = null;
    public formatTypeOptions: SelectedValueModel[] = [];
    public timeTypeOptions: SelectedValueModel[] = [];
    public metricTypeOptions: SelectedValueModel[] = [];
    public selectedMetricType: SelectedValueModel;
    public validationFlags: MetricValidationFlags = {
        nameExists: true,
        nameUnique: true,
        nameLength: true,
        nameChars: true,
        category: true,
        aggregation: true,
        format: true,
        direction: true,
        description: true,
        reportingSet: true,
        metricDate: true,
        metricDataValue: true,
        metricEndDate: true,
        formulaInvalid: true,
        formulaEmpty: true,
        formulaOperator: true,
        formulaInvalidMetric: true,
        formulaSpecialCharacter: true,
        formulaMissingMetric: true,
        displayCalculatedErrorMessage: false,
        aggregationChanged: false,
        formatTypeChanged: false,
        metricDateChanged: false,
        addFiltersChanged: false,
        metricDataValueChanged: false,
        metricEndDateChanged: false,
        metricNameChanged: false,
        rootMetricBeingUsedInFormula: true,
        templatePlaceholder: false,
    };
    public reportingSets: ReportingSetDefinition[] = null;  //previously []
    public selectedReportingSet: ReportingSetDefinition;
    public reportingSetOptions: SelectedValueStringModel[] = [];
    public reportingSetCurrent: SelectedValueStringModel;
    public selectedMetricDates: SelectedCategoryModel[] = [];
    public selectedMetricDate: SelectedCategoryModel;
    public selectedDefaultDate: SelectedCategoryModel;
    public selectedDataValue: SelectedCategoryModel;
    public selectedEndDate: SelectedCategoryModel;
    public defaultDateOptions: SelectedCategoryModel[] = [];
    public dataValueOptions: SelectedCategoryModel[] = [];
    public metricValue: MetricValue = "Data field";
    public metricDateOptions: SelectedCategoryModel[] = [];
    private spanCounter: number = 0;
    public inProgressMetricList: string[];

    public isDisabled: boolean = true;
    public isBlocked: boolean = false;
    public isEditingDisabled = false;
    public isActionRunning = false;

    @ViewChild('metricModal') assocMetricModal: AssociatedMetricsComponent;
    @ViewChild('filterFields') filterFieldsModal: FilterFieldsEditComponent;

    private pointsOfContact: Map<number, GroupDTO> = null;
    private skills: Map<number, GroupDTO> = null;
    private campaigns: Map<number, GroupDTO> = null;
    private companies: Map<number, GroupDTO> = null;

    private assignModal: DynamicDialogRef;
    public assignments: GroupAssignment[] = [];
    public assignmentsSize: string = "assignmentsGrid-sm";
    public assignmentsGridOptions: GridOptions = null;
    public assignmentsSearchPlaceholder: string = "";
    public assignmentsLabel: string = "";

    public calculatedMetricHTML: string = "";
    public calculatedMetricModel: string = "";
    public showCalculated: boolean = false;
    public createMetricTypeOptions: SelectedValueModel[] = [];
    public showMetricSelector: boolean = false;
    public selectedCalculatedMetric: string;
    public calculatedMetricDiff: string = "<p></p>"

    public contextStartIndex: number = -1;
    public contextEndIndex: number = -1;
    public contextMetricCounter: number = 0;
    public contextOperatorCounter: number = 0;
    public bookmarkSpan: string = "";
    public bookmarkID: number = 0;
    public bookmark: any = null;
    public ed: any;
    public firstCalculatedEdit: boolean = false;
    public firstCalculatedEditString: string = "";
    public originalCalculatedFormula: string = "";
    public formulaError: string = "";
    public editorPasteFlag = false;
    public editorPasteLength = 0;

    public editWarningString: string = "Existing workflows may get affected if you edit metrics.";
    private cancelMessageModalRef: DynamicDialogRef = null;
    public recalculationInProgress = false;
    public recalculationInProgressMessage: string;
    public recalculationComplete = false;
    public recalculationCompleteMessage: string;
    public showSpinner: boolean;
    public moreDetailsMessage: string;
    public recalculationStatusMessage = false;
    public lastModifiedDate: string;
    public isStandardMetric: boolean;
    public isNewMetric = false;
    public initiatedBy: string;
    public recalculateDate: string;
    public definitions: string;
    public isRecalculationComplete = true;
    public modal: modalDetails;
    public isMetricAvailable = false;
    public loggedInUser: string;
    public hideCompletedMessage = false;
    public isDuplicate: boolean = false;
    public formulaIsValid: boolean = false;
    public isMetricNameChanged = false;
    public recalculatingMetrics: Set<string> = new Set<string>();
    public timer = null;
    public intervalTime = 60000;
    public isRecalculationModalOpen: boolean = false;
    private typingTimer: any;
    private typedString = "";

    constructor(
        private cvLocalizationFactory: CVLocalizationService,
        private agGridHelperService: AgGridHelperService,
        public manageMetricsService: CxoneManageMetricsService,
        private modalService: NgbModal,
        public toastrManager: ToastrManager,
        private _dialogService: DialogService,
        private navSrvc: NavigationService,
        public metricSelectorService: MetricSelectorService,
        private cxoneEtlDataRecalculationService: CxoneEtlDataRecalculationService,
        private ngZone: NgZone,
        private cdr: ChangeDetectorRef,
    ) {
    }

    async ngOnInit() {
        window["selfmetric"] = this;
        (window as any).toggleMetricSelector = this.toggleMetricSelector.bind(this);
        this.localization = await this.cvLocalizationFactory.GetSection("CXOne_Manage_Metrics");
        this.localizationCommon = await this.cvLocalizationFactory.GetSection("Common");
        this.localizationDescriptions = await this.cvLocalizationFactory.GetSection("Metric_Descriptions");

        this.hasPMLicense = this.navSrvc.hasPartnerPMAccess;
        this.permissions = await this.manageMetricsService.getManageMetricsPermissions();

        this.metricDefinitionsData = await this.manageMetricsService.getMetricDefinitions();

        this.localizeLockedMetricDescriptions();

        this.setupAgGrid();

        this.radioUpLabel = this.getLocalizationString('Metric_Direction_Up', 'Up');
        this.radioDownLabel = this.getLocalizationString('Metric_Direction_Down', 'Down');
        this.updateNoRowsMessage();
        this.editWarningString = this.getLocalizationString("Edit_Warning_Message", "Existing workflows may get affected if you edit metrics.");
        this.moreDetailsMessage = this.getLocalizationString("More_Details","More details");
        this.recalculationCompleteMessage = this.getLocalizationString("Recalculation_Complete_Message", "Recalculation completed successfully.");
        this.recalculationInProgressMessage = this.getLocalizationString("Recalculation_InProgress_Message", "Recalculation is in progress. Changes cannot be made.");
        this.loggedInUser = this.navSrvc.loggedInName;
    }

    public openModal() {
        const dialogRef = this._dialogService.open(ManageMetricsRecalculationDetailsModalComponent, {
            width: "500px",
            height: "362px",
            styleClass: 'cx-one-ui',
            data: {
                metricsName: this.selectedMetricRow.MetricName,
                modalDetails: this.modal,
            }
        });
    }

    public async getConfigurationData() {
        this.reportingSets = await this.manageMetricsService.getReportingSets();
        this.reportingSetOptions = this.reportingSets != null ? this.reportingSets.map((item) => ({ name: item?.ReportingSetName, value: item?._id })) : [];
    }

    public async getSetRecGroup() {
        let recGroups = await this.manageMetricsService.getRecGroups();
        this.pointsOfContact = recGroups.pointsOfContact;
        this.skills = recGroups.skills;
        this.campaigns = recGroups.campaigns;
        this.companies = recGroups.companies;
    }

    private async loadGroupTypes() {
        this.groupTypes = await this.manageMetricsService.getGroupTypes();
    }

    async getInProgressRecalculation(): Promise<string[]> {
        try {
            const response = await this.cxoneEtlDataRecalculationService.loadData();
            const recalculationInProgress = response.filter(metricDef =>
                metricDef.type === 'Metric' &&
                !metricDef.completed
            );
            this.inProgressMetricList = recalculationInProgress.length > 0 ? recalculationInProgress.map(metric => metric.definitions) : [];
            return this.inProgressMetricList;
        } catch (error) {
            console.error("Failed to load recalculation data");
            //throw error;
        }
    }

    public applyFilter() {
        if (this.agGrid?.api) {
            this.curMetricCount = 0;
            this.agGrid?.api.onFilterChanged();

            if (this.agGrid?.api?.getDisplayedRowCount() === 0) {
                this.agGrid?.api.showNoRowsOverlay();
            }
            else
                this.agGrid?.api?.hideOverlay();
        }
    }

    public setupAgGrid() {
        this.gridOptions = this.agGridHelperService.createGridOptions({
            columnTypes: {
                simpleContextMenu: {
                    cellRendererSelector: (param) => {
                        if (param.data == null || 
                            !this.permissions?.WriteAccess || 
                            !this.hasPMLicense || 
                            (param.data.Type != MetricTypes.Calculated && param.data.Type != MetricTypes.Standard)) {
                            return null;
                        }
                        return { component: 'contextMenuCellRenderer' };
                    }
                },
            },
            columnDefs: [
                {
                    field: "Group",
                    colId: "Group",
                    headerName: this.localization != null ? this.localization.get("Category") : "Category",
                    rowGroup: true,
                    hide: true,
                    suppressSizeToFit: true,
                    resizable: true,
                    sortable: true
                },
                {
                    field: "MetricID",
                    colId: "MetricID",
                    headerName: this.localization != null ? this.localization.get("ID_Header") : "ID",
                    valueFormatter: (params) => {
                        if (params.value != null)
                            return params.value.toString();
                        else
                            return "";
                    },
                    cellRenderer: 'cxoneMetricNameCellRendererComponent',
                    suppressSizeToFit: true,
                    width: 100,
                    resizable: true,
                    sortable: true
                },
                {
                    field: "Abreviation",
                    colId: "Abreviation",
                    headerName: this.localization != null ? this.localization.get("Metric_Name") : "Metric Name",
                    menuTabs: ['generalMenuTab'],
                    sort: "asc",
                    sortIndex: 1,
                    cellRenderer: 'cxoneMetricNameCellRendererComponent',
                    cellRendererParams: { 
                        text: this.localization != null ? this.localization.get('Calculated_Metric') : "Calculated Metric"
                    },
                    suppressSizeToFit: true,
                    resizable: true,
                    sortable: true,
                    width: 300,
                    valueFormatter: (params) => {
                        if (params.value != null)
                            return params.value.toString();
                        else
                            return "";
                    }
                },
                {
                    field: "MetricDescription",
                    colId: "MetricDescription",
                    headerName: this.localization != null ? this.localization.get("Description") : "Description",
                    cellRenderer: 'cxoneMetricNameCellRendererComponent',
                    valueFormatter: (params) => {
                        if (params.value != null)
                            return params.value.toString();
                        else
                            return "";
                    },
                    flex: 1,
                    resizable: true,
                    sortable: true
                },
                {
                    colId: "lockIconCol",
                    cellRenderer: 'lockIconCellRenderer',
                    cellRendererParams: {popover: this.localization != null ? this.localization.get('Locked_Metric_Tooltip') : "Cannot edit or delete"},
                    width: !this.permissions?.WriteAccess ? 48 : 20,
                    suppressSizeToFit: true,
                    resizable: false,
                    sortable: false
                },
                {
                    colId: "contextMenu",
                    type: "simpleContextMenu",
                    width: 48,
                    suppressSizeToFit: true,
                    cellStyle: { "text-overflow": "unset" },
                    resizable: false,
                    sortable: false
                }
            ],
            defaultColDef: {
                sortable: false,
                //cellClass: "d-flex align-items-center",
                menuTabs: [],
                resizable: false,
                icons: {
                    sortAscending: '<div class="sortIcons mb-0"><svg class="icon-10" style="fill: #758994;"><use href="../App_Themes/CXone/icons/arrow-up.svg#arrow-up"></use></svg></div>',
                    sortDescending: '<div class="sortIcons mb-0"><svg class="icon-10" style="fill: #758994;"><use href="../App_Themes/CXone/icons/arrow-down.svg#arrow-down"></use></svg></div>',
                    filter: '<svg class="icon-20 fill-iconMenu"><use href="../App_Themes/CXone/icons/filter.svg#filter"></use></svg>',
                    menu: '<svg class="icon-20 fill-iconMenu"><use href="../App_Themes/CXone/icons/widget-menu.svg#widget-menu"></use></svg>',
                    columns: '<svg class="icon-20 fill-iconMenu"><use href="../App_Themes/CXone/icons/chart.svg#chart"></use></svg>',
                }
            },
            autoGroupColumnDef: {
                headerName: this.localization != null ? this.localization.get("Category") : "Category",
                cellRenderer: 'agGroupCellRenderer',
                cellRendererParams: {
                    suppressCount: true,
                    innerRenderer: 'cxoneMetricNameCellRendererComponent',
                },
                sort: "asc",
                sortIndex: 0,
                valueFormatter: (params) => {
                    if (params.value != null)
                        return params.value.toString();
                    else
                        return "";
                },
                suppressSizeToFit: true,
                lockPosition: true,
                resizable: true,
                sortable: true,
                width: 120,
                cellStyle: {'display': 'block'}
            },
            onGridReady: params => {
                this.agGrid?.api?.setGridOption('rowData', this.metricDefinitionsData);
            },
            onBodyScroll: params => {
                this.agGrid?.api?.hidePopupMenu();
            },
            components: {
                contextMenuCellRenderer: ContextMenuCellRendererComponent,
                cxoneMetricNameCellRendererComponent: CxoneMetricNameCellRendererComponent,
                lockIconCellRenderer:LockIconCellRendererComponent,
                agColumnHeader: CxoneColumnHeaderRendererComponent,
            },
            onCellClicked: async (event) => {
                //check to make sure the click did not happen on a group row, if failed this validation just return
                if (event.node.field == "Group") //removing check for event.colDef.showRowGroup == true to allow opening preview when clicking the group column (other than the group heading)
                    return;
                //validate that the column clicked is not the context menu either (no category and no context columns)
                if (event.colDef.colId == 'contextMenu'){
                    return;
                }

                this.selectedMetricRow = cloneDeep(event.data);
                this.origSelectedMetricRow = cloneDeep(this.selectedMetricRow);
                this.selectedMetricType = this.selectedMetricRow.Type == MetricTypes.Calculated ? { name: this.localization.get("Metric_Type_Calculated"), value: 1 } : { name: this.localization.get("Metric_Type_Standard"), value: 2 };

                this.getMetricConfigurationData();
                this.selectedRadioValue = this.selectedMetricRow.Direction.toString();
                this.setCategoryOptions();
                this.selectedCategoryValue = { "name": this.selectedMetricRow.Group };


                if(this.reportingSets == null) {
                    await this.getSetRecGroup();  
                } 
                this.setGroupValues();
                this.setAggregationOptions();
                this.setAggregationValue();
                this.setFormatOptions();
                this.setFormatValue();
                this.setTimeTypeOptions();
                this.setTimeTypeValue();
                this.setupAssignments();
                this.resetValidationFlags();
                this.showDetailView = true;

                this.calculatedMetricStringSetUp();
                this.isDisabled = true;
            },
            getRowId: ({ data: rowData }) => rowData.MetricID,
            isExternalFilterPresent: () => true,
            doesExternalFilterPass: (node) => {
                let result = this.agGridHelperService.doesExternalFilterPassIncludeHidden(node, this.searchValue);
                if (result == true)
                    this.curMetricCount++;

                return result;
            },
            onFilterChanged: () => {
                this.agGrid?.api.redrawRows();
            },
            context: {
                DeactivateMetric: () => this.deactivateMetric(this.selectedMetric.MetricID),
                getFilterText: () => this.searchValue,
                editClick: (metricDefinition) => this.contextMenuEditClick(metricDefinition),
                duplicateClick: (metricDefinition) => this.contextMenuDuplicateClick(metricDefinition),
                recalculationClick: (metricDefinition) => this.contextMenuRecalculationClick(metricDefinition),
                deleteClick: (metricDefinition) => this.confirmDashboardDelete(metricDefinition),
                getCreatePermission:() => this.permissions.CreateAccess,
                isRecalculationInProgress: (metricName) => this.isRecalculationInProgress(metricName)
            },
            getMainMenuItems: (params: any) => {
                const menuItems = this.getMainMenuItems();
                return menuItems;
            },
            onColumnResized: () => {
                this.agGrid.api?.hidePopupMenu();
            },
            popupParent: document.querySelector('ag-grid-angular'), //keeps the context menu within the bounds of the grid
            suppressRowClickSelection: true,
            suppressContextMenu: true,
            suppressCellFocus: true,
            suppressMovableColumns: true,
            rowClass: 'cx-one-ui',
            groupDefaultExpanded: 1,
            rowHeight: 36,
            headerHeight: 44,
            scrollbarWidth: 8
        });
    }

    updateNoRowsMessage() {
        this.gridOptions.overlayNoRowsTemplate = `<div>
                                                    <svg class="cxoneFavoriteState mb-2">
                                                        <use href="../App_Themes/CXone/icons/no-results.svg#no-results"></use>
                                                    </svg>
                                                    <p class="cxoneEmptyText">${this.cvLocalizationFactory.getCachedText("CXOne_Manage_Metrics", "No_Results", "No results found")}</p>
                                                </div>`;
    }

    getMainMenuItems() {
        let menuItems = ["pinSubMenu", "autoSizeThis", "autoSizeAll", "resetColumns"];
        return menuItems;
    }

    getLocalizationString(key: string, defaultValue: string) {
        return this.cvLocalizationFactory.getCachedText("CXOne_Manage_Metrics", key, defaultValue);
    }
    getLocalizationStringUpper(key: string, defaultValue: string) {
        return this.cvLocalizationFactory.getCachedText("CXOne_Manage_Metrics", key, defaultValue).toUpperCase();
    }

    getLocalizationStringProper(key: string, defaultValue: string) {
        let str = this.cvLocalizationFactory.getCachedText("CXOne_Manage_Metrics", key, defaultValue);
        let tmp = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        return tmp;
    }

    getLocalizationStringProperSingle(key: string, defaultValue: string) {
        let str = this.cvLocalizationFactory.getCachedText("CXOne_Manage_Metrics", key, defaultValue);
        let tmp = str.split(" ");

        let finalString = tmp.map(item => {
            return item[0].toUpperCase() + item.substring(1);
        }).join(" ");

        return finalString;
    }

    public async isRecalculationInProgress(metricName: string): Promise<boolean> {
        await this.recalculationStatus();
        return this.recalculatingMetrics.has(metricName);
    }

    public updateCategory(e: SelectedCategoryModel) {
        this.selectedMetricRow.Group = e.name;
    }

    public updateRadioValue(e: string) {
        if (e == "0")
            this.selectedMetricRow.Direction = 0;
        else if (e == "1")
            this.selectedMetricRow.Direction = 1;
    }

    public addCategoryOption(event) {
        if (event.text != "" && event.text != undefined && event.text != null) {
            let newItems = [{ "name": event.text }];
            this.categoryOptions = this.categoryOptions.concat(newItems);
            this.selectedCategoryValue = newItems[0];
            this.selectedMetricRow.Group = newItems[0].name;
        }
        this.validateCategory();
    }

    setAggregationOptions() {
        this.aggregationOptions.push({ name: this.getLocalizationString('Sum', "Sum"), value: 0 });
        if (this.selectedMetricRow.AggregationType != null && this.selectedMetricRow.AggregationType == AggregationType.Min) {
            this.aggregationOptions.push({ name: this.getLocalizationString('Min', "Min"), value: 1 });
        }
        this.aggregationOptions.push({ name: this.getLocalizationString('Max', "Max"), value: 2 });
    }

    setCategoryOptions() {
        let uniqueCategories = [...new Set(this.metricDefinitionsData.map(item => item.Group))];
        this.categoryOptions = [];
        for (var i = 0; i < uniqueCategories.length; i++) {
            this.categoryOptions.push({ "name": uniqueCategories[i] });
        }
    }

    setAggregationValue() {
        if (this.selectedMetricRow.AggregationType == AggregationType.Sum)
            this.selectedAggregationValue = { name: this.getLocalizationString('Sum', "Sum"), value: 0 };
        else if (this.selectedMetricRow.AggregationType == AggregationType.Min) {
            this.selectedAggregationValue = { name: this.getLocalizationString('Min', "Min"), value: 1 };
        }
        else if (this.selectedMetricRow.AggregationType == AggregationType.Max)
            this.selectedAggregationValue = { name: this.getLocalizationString('Max', "Max"), value: 2 };
        else
            this.selectedAggregationValue = null;
    }

    public updateAggregation(e: SelectedValueModel) {
        if (e.value == 0)
            this.selectedMetricRow.AggregationType = AggregationType.Sum;
        else if (e.value == 1)
            this.selectedMetricRow.AggregationType = AggregationType.Min;
        else if (e.value == 2)
            this.selectedMetricRow.AggregationType = AggregationType.Max;

        this.validationFlags.aggregation = true;
        this.selectedAggregationValue = e;
        this.validationFlags.aggregationChanged = true;
    }

    setFormatOptions() {
        if (this.formatTypeOptions.length > 0) //already filled so end
            return;

        this.formatTypeOptions.push({ name: this.getLocalizationString('Currency', "Currency"), value: 0 });
        this.formatTypeOptions.push({ name: this.getLocalizationString('Number', "Number"), value: 1 });
        this.formatTypeOptions.push({ name: this.getLocalizationString('Percent', "Percent"), value: 2 });
        this.formatTypeOptions.push({ name: this.getLocalizationString('Time', "Time"), value: 3 });
    }

    setTimeTypeOptions() {
        if (this.timeTypeOptions.length > 0) //already filled so end
            return;

        this.timeTypeOptions.push({ name: this.getLocalizationString('Seconds', "Seconds"), value: 1 });
        this.timeTypeOptions.push({ name: this.getLocalizationString('Minutes', "Minutes"), value: 2 });
        this.timeTypeOptions.push({ name: this.getLocalizationString('Hours', "Hours"), value: 3 });
        this.timeTypeOptions.push({ name: "HH:MM:SS", value: 4 });
    }

    async setGroupValues() {
        if(this.groupTypes == null)
            await this.loadGroupTypes();

        for (var i = 0; i < this.groupTypes.emp.length; i++) {
            if (this.selectedMetricRow.EmpLevelMin == this.groupTypes.emp[i].GroupLevel) {
                this.selectedEmpValue = this.groupTypes.emp[i];
                break;
            }
        }

        for (var i = 0; i < this.groupTypes.rec.length; i++) {
            if (this.selectedMetricRow.RecLevelMin == this.groupTypes.rec[i].GroupLevel) {
                this.selectedRecValue = this.groupTypes.rec[i];
                break;
            }
        }
    }

    setFormatValue() {
        if (this.selectedMetricRow.NumericType == 0)
            this.selectedFormatValue = { name: this.getLocalizationString('Currency', "Currency"), value: 0 };
        else if (this.selectedMetricRow.NumericType == 1)
            this.selectedFormatValue = { name: this.getLocalizationString('Number', "Number"), value: 1 };
        else if (this.selectedMetricRow.NumericType == 2)
            this.selectedFormatValue = { name: this.getLocalizationString('Percent', "Percent"), value: 2 };
        else if (this.selectedMetricRow.NumericType == 3)
            this.selectedFormatValue = { name: this.getLocalizationString('Time', "Time"), value: 3 };
        else
            this.selectedFormatValue = null;
    }

    setTimeTypeValue() {
        if (this.selectedMetricRow.TimeFormat == TimeFormat.None)
            this.selectedTimeValue = { name: this.getLocalizationString('None', "None"), value: 0 };
        else if (this.selectedMetricRow.TimeFormat == TimeFormat.Second)
            this.selectedTimeValue = { name: this.getLocalizationString('Seconds', "Seconds"), value: 1 };
        else if (this.selectedMetricRow.TimeFormat == TimeFormat.Minute)
            this.selectedTimeValue = { name: this.getLocalizationString('Minutes', "Minutes"), value: 2 };
        else if (this.selectedMetricRow.TimeFormat == TimeFormat.Hour)
            this.selectedTimeValue = { name: this.getLocalizationString('Hours', "Hours"), value: 3 };
        else if (this.selectedMetricRow.TimeFormat == TimeFormat.Time)
            this.selectedTimeValue = { name: "HH:MM:SS", value: 4 };
        else
            this.selectedTimeValue = null;
    }

    public updateFormatType(e: SelectedValueModel) {
        if (e.value == 0) {
            this.selectedMetricRow.NumericType = 0;
        }
        else if (e.value == 1) {
            this.selectedMetricRow.NumericType = 1;
        }
        else if (e.value == 2) {
            this.selectedMetricRow.NumericType = 2;
        }
        else if (e.value == 3) {
            this.selectedMetricRow.NumericType = 3;
        }

        this.selectedTimeValue = { name: this.getLocalizationString('None', "None"), value: 0 };
        this.selectedMetricRow.TimeFormat = TimeFormat.None;
        this.validationFlags.format = true;
        this.selectedFormatValue = e;
        this.validationFlags.formatTypeChanged = true;
    }

    public updateTimeType(e: SelectedValueModel) {
        if (e.value == 0) {
            this.selectedMetricRow.TimeFormat = TimeFormat.None;
        }
        else if (e.value == 1) {
            this.selectedMetricRow.TimeFormat = TimeFormat.Second;
        }
        else if (e.value == 2) {
            this.selectedMetricRow.TimeFormat = TimeFormat.Minute;
        }
        else if (e.value == 3) {
            this.selectedMetricRow.TimeFormat = TimeFormat.Hour;
        }
        else if (e.value == 4) {
            this.selectedMetricRow.TimeFormat = TimeFormat.Time;
        }

        this.validationFlags.format = true;
    }

    public updateAbbrev(e: string) {
        this.selectedMetricRow.Abreviation = e.trim().replace(/\s+/g, ' ');
    }

    public updateEmpMin(e: GroupType) {
        this.selectedMetricRow.EmpLevelMin = e.GroupLevel;
    }

    public updateRecMin(e: GroupType) {
        this.selectedMetricRow.RecLevelMin = e.GroupLevel;
    }

    public async recalculationStatus() {
        const response = await this.cxoneEtlDataRecalculationService.loadData();
        this.recalculatingMetrics.clear();
        const recalculationInProgress = response.filter(metricDef =>
            metricDef.type === 'Metric' && !metricDef.completed
        );
        let metric = this.isNewMetric ? this.selectedMetricRow : this.origSelectedMetricRow;
        const currentMetricsRecalcInProgress = response.filter(metricDef =>
            metricDef.type === 'Metric' &&
            metricDef.definitions === metric?.MetricName &&
            !metricDef.completed
        );
        this.isEditingDisabled = currentMetricsRecalcInProgress?.length > 0;
    
        recalculationInProgress.forEach(metricDef => {
            const metrics = metricDef.definitions.split(', ');
            metrics.forEach(def => {
                this.recalculatingMetrics.add(def);
            });
        });
        return response;
    }
    
    public async validateRecalculationStatus() {
        const response = await this.recalculationStatus();
        if (response && response.length > 0) {
            let lastModifiedDateFound = false;
            response.forEach(item => {
                let isMetricMatched = false;
                let definition: string;
                const metrics = item.definitions.split(', ');
                metrics.forEach(def => {
                    if (def === this.selectedMetricRow.MetricName) {
                        definition = def;
                        isMetricMatched = true;
                    }
                });

                if (!lastModifiedDateFound && item.completed && item.type === 'Metric' && isMetricMatched) {
                    const lastModifiedDate = item.lastModifiedDate ? new Date(item.lastModifiedDate) : null;
                    const today = new Date();
                    if (lastModifiedDate) {
                        const lastModifiedDateStr = moment(lastModifiedDate).format('MMM DD, YYYY').toLocaleString();
                        const todaysDate = moment(today).format('MMM DD, YYYY').toString();
                        this.lastModifiedDate = lastModifiedDateStr;
                        if (this.lastModifiedDate === todaysDate) {
                            this.recalculationStatusMessage = true;
                        } else {
                            this.recalculationStatusMessage = false;
                        }
                        lastModifiedDateFound = true;
                    }
                }
                if (!item.completed && isMetricMatched) {
                    this.recalculatingMetrics.add(definition);
                    this.recalculationStatusMessage = false;
                }
            });
        }
        this.createModalDetails(response);
        this.showSpinner = false;
    }

    public createModalDetails(response) {
        this.initiatedBy = null;
        this.recalculateDate = null;
        this.lastModifiedDate = null;
        this.definitions = null;
        this.isRecalculationComplete = true;
        this.isMetricAvailable = false;

        let lastModifiedDateStr: string | null = null;
        if (response && response.length > 0) {
            let lastModifiedDateFound = false;

            response.forEach(item => {
                let isMetricMatched = false;
                let definition: string;
                let metrics = item.definitions.split(', ');
                metrics.forEach(def => {
                    if (def === this.selectedMetricRow.MetricName) {
                        definition = def;
                        isMetricMatched = true;
                        this.isMetricAvailable = true;
                    }
                });

                if (!lastModifiedDateFound && item.completed && (item.type === 'Metric') && isMetricMatched) {
                    if (!this.initiatedBy || this.initiatedBy === '') {
                        this.initiatedBy = item.initiatedBy;
                        this.recalculateDate = (item?.recalcStart ? moment(item?.recalcStart).format('MMM D, YYYY') : '') + ' - ' +
                            (item?.recalcEnd ? moment(item?.recalcEnd).format('MMM D, YYYY') : '');

                        if (this.loggedInUser == this.initiatedBy) {
                            this.hideCompletedMessage = true;
                        } else {
                            this.hideCompletedMessage = false;
                        }
                    }
                    this.definitions = definition;
                    const lastModifiedDate = item.lastModifiedDate ? new Date(item.lastModifiedDate) : null;
                    if (lastModifiedDate) {
                        lastModifiedDateStr = moment(lastModifiedDate).format('MMM DD, YYYY').toLocaleString();
                        this.lastModifiedDate = lastModifiedDateStr;
                        lastModifiedDateFound = true;
                    }
                } else if (!item.completed && (item.type === 'Metric') && isMetricMatched) {
                    this.initiatedBy = item.initiatedBy;
                    this.recalculateDate = (item?.recalcStart ? moment(item?.recalcStart).format('MMM D, YYYY') : '') + ' - ' +
                        (item?.recalcEnd ? moment(item?.recalcEnd).format('MMM D, YYYY') : '');
                    this.definitions = definition;
                    this.isRecalculationComplete = false;
                }
            });

            this.modal = {
                initiatedBy: this.initiatedBy,
                lastModified: this.lastModifiedDate,
                recalculationDate: this.recalculateDate,
                def: this.definitions,
                recalcComplete: this.isRecalculationComplete
            }
        }
    }

    public validateMetricName() {
        let duplicateFlag = false;
        for (var i = 0; i < this.metricDefinitionsData.length; i++) {
            if ((this.metricDefinitionsData[i].MetricName.toLowerCase() == this.selectedMetricRow.MetricName.trim().replace(/\s+/g, ' ').toLowerCase()) && (this.metricDefinitionsData[i].MetricID != this.selectedMetricRow.MetricID)) {
                duplicateFlag = true;
                break;
            }
        }

        if (duplicateFlag) {    //check for name already exists
            this.validationFlags.nameUnique = false;
        }
        else
            this.validationFlags.nameUnique = true;

        if (this.selectedMetricRow.MetricName.trim().replace(/\s+/g, ' ').length > 30) {    //check for length > 30 //original name length could be 50 and abbrev could be 20 but since for this case they are matching so we decided on 30
            this.validationFlags.nameLength = false;
        }
        else
            this.validationFlags.nameLength = true;

        let format = /[+\/*<>=^:()~]/; //updating this to allow % to pass
        if (format.test(this.selectedMetricRow.MetricName)) {    //check for unsupported characters
            this.validationFlags.nameChars = false;
        }
        else
            this.validationFlags.nameChars = true;

        if (this.selectedMetricRow.MetricName == null || this.selectedMetricRow.MetricName == "")
            this.validationFlags.nameExists = false;
        else
            this.validationFlags.nameExists = true;
    }

    public validateMetricDescription() {
        if (this.selectedMetricRow.MetricDescription.length > 1000) {    //check for length > 1000
            this.validationFlags.description = false;
        }
        else
            this.validationFlags.description = true;
    }

    public validateCategory() {
        if (this.selectedMetricRow.Group == "" || this.selectedMetricRow.Group.length > 50) {    //check for null or length > 50
            this.validationFlags.category = false;
        }
        else
            this.validationFlags.category = true;
    }

    public validateAggregationType() {
        if (this.selectedMetricRow.AggregationType == null) {
            this.validationFlags.aggregation = false;
        }
        else
            this.validationFlags.aggregation = true;
    }

    public validateFormatType() {
        if (this.selectedMetricRow.NumericType == null) {
            this.validationFlags.format = false;
        }
        else if (this.selectedMetricRow.NumericType == 3) {   //if time type is selected then check time format
            switch (this.selectedMetricRow.TimeFormat) {
                case TimeFormat.Second:
                case TimeFormat.Minute:
                case TimeFormat.Hour:
                case TimeFormat.Time:
                    this.validationFlags.format = true;
                    break;
                default:
                    this.validationFlags.format = false;
                    break;
            }
        }
        else
            this.validationFlags.format = true;
    }

    public validateReportingSetInfo() {

        if (this.metricValue == "Data field") {
            if (this.selectedDataValue == null) {
                this.validationFlags.metricDataValue = false;
            }
            else {
                this.validationFlags.metricDataValue = true;
            }
        }
        else {
            this.validationFlags.metricDataValue = true;
        }

        if (this.metricValue == "Time") {
            if (this.selectedEndDate == null) {
                this.validationFlags.metricEndDate = false;
            }
            else {
                this.validationFlags.metricEndDate = true;
            }
        }
        else {
            this.validationFlags.metricEndDate = true;
        }

        if (this.selectedReportingSet == null) {
            this.validationFlags.reportingSet = false;
        }
        else {
            this.validationFlags.reportingSet = true;
        }

        if (this.selectedMetricDate == null && this.selectedDefaultDate == null) {
            this.validationFlags.metricDate = false;
        }
        else {
            this.validationFlags.metricDate = true;
        }

    }

    public confirmCancel() {

        if (this.triggerCancelConfirm())
            this.showMessageModal();
        else
            this.backClick();
    }

    public backClick() {

        this.selectedMetricRow = null;
        this.reportingSetCurrent = null;
        this.selectedReportingSet = null;
        this.origSelectedMetricRow = null;
        this.selectedRadioValue = "0";
        this.categoryOptions = [];
        this.selectedCategoryValue = null;
        this.aggregationOptions = [];
        this.selectedAggregationValue = null;
        this.selectedFormatValue = null;
        this.selectedEmpValue = null;
        this.selectedRecValue = null;
        this.showDetailView = false;
        this.showCreateView = false;
        this.assignments = [];

        this.isDisabled = true;
        this.isDuplicate = false;
        this.showMetricSelector = false;
        this.selectedCalculatedMetric = "";
        this.calculatedMetricHTML = "";
        this.showCalculated = false;
        this.calculatedMetricModel = "";
        this.bookmarkSpan = "";
        this.selectedMetricType = null;
        this.spanCounter = 0;
        this.ed = null;

        this.calculatedMetricDiff = "<p></p>";
        this.bookmarkID = 0;
        this.originalCalculatedFormula = "";
        sendMessageCXOne({ hasNonSavedChanges: false });
        this.formulaIsValid = false;
        this.isRecalculationModalOpen = false;        
    }

    public previewEditClick() {
        if(this.hasPMLicense){
            this.showCreateView = true;
            this.showDetailView = false;
            this.validateMetricName(); //checks that the current name meets the validation requirements and set the border to red if it fails

            this.validateRecalculationStatus();
            this.isNewMetric = false;
            this.isStandardMetric = this.selectedMetricRow.Type === 0;

            this.isDisabled = false;
            this.assignmentsGridOptions = null;
            this.agGridAssignments = null;
            this.setupAssignments();

            this.metricTypeOptions = [{ name: this.localization.get("Metric_Type_Calculated"), value: 1 }, { name: this.localization.get("Metric_Type_Standard"), value: 2 }];

            //I have to save the old preview formula so I can set it later in case they edit and then hit the back button. 
            if (this.selectedMetricRow.Type == MetricTypes.Calculated) {
                //here just checking if the tinymce global variable is set. If it's not then set it to the tinymce active editor
                this.firstCalculatedEditString = this.selectedMetricRow.CalculatedFormula;
                this.originalCalculatedFormula = this.selectedMetricRow.CalculatedFormula;
                this.firstCalculatedEdit = true;
                this.calculatedMetricModel = this.selectedMetricRow.CalculatedFormula;

                this.showCalculated = true;
                this.validationFlags.formulaInvalid = true;
                this.validationFlags.formulaEmpty = true;
            }
        }
        else{
            let modal = document.getElementById("PMLicenseModalEditMetric") as HTMLElement;

            if(modal != null)
                modal.style.display = (modal.style.display === 'block') ? 'none' : 'block';
        }
    }

    public contextMenuDuplicateClick(def: MetricDefinition) {
        let duplicateDef = cloneDeep(def);
        duplicateDef.MetricID = 0;
        this.contextMenuEditClick(duplicateDef, true);
        sendMessageCXOne({ hasNonSavedChanges: true });
    }

    public contextMenuEditClick(def: MetricDefinition, isDuplicate: boolean = false) {
        this.isDuplicate = isDuplicate;
        this.showSpinner = true;
        this.selectedMetricRow = cloneDeep(def);
        this.origSelectedMetricRow = cloneDeep(this.selectedMetricRow);
        if(this.isDuplicate){
            this.selectedMetricRow.MetricName = this.selectedMetricRow.MetricName + "_Copy";
            this.updateAbbrev(this.selectedMetricRow.MetricName);
            this.selectedMetricRow.IsEditable = true;
        }
        this.getMetricConfigurationData();

        if(this.reportingSets == null) {
             this.getSetRecGroup();  
        } 

        this.selectedRadioValue = this.selectedMetricRow.Direction.toString();
        this.setCategoryOptions();
        this.selectedCategoryValue = { "name": this.selectedMetricRow.Group };

        this.setGroupValues();
        this.setAggregationOptions();
        this.setAggregationValue();
        this.setFormatOptions();
        this.setTimeTypeOptions();
        this.setFormatValue();
        this.setTimeTypeValue();
        this.setupAssignments();
        this.resetValidationFlags();
        this.isDisabled = false;
        this.showCreateView = true;
        this.showDetailView = false;
        this.validateMetricName();
        this.validateRecalculationStatus();
        this.isNewMetric = this.isDuplicate;
        
        this.isStandardMetric = def.Type === 0;

        this.setupAssignments();

        this.metricTypeOptions = [{ name: this.localization.get("Metric_Type_Calculated"), value: 1 }, { name: this.localization.get("Metric_Type_Standard"), value: 2 }];

        this.selectedMetricType = this.selectedMetricRow.Type == MetricTypes.Calculated ? { name: this.localization.get("Metric_Type_Calculated"), value: 1 } : { name: this.localization.get("Metric_Type_Standard"), value: 2 };
        this.metricTypeOptions = [{ name: this.localization.get("Metric_Type_Calculated"), value: 1 }, { name: this.localization.get("Metric_Type_Standard"), value: 2 }];

        //I have to save the old preview formula so I can set it later in case they edit and then hit the back button. 
        if (this.selectedMetricRow.CalculatedFormula != null) {
            //here just checking if the tinymce global variable is set. If it's not then set it to the tinymce active editor
            this.firstCalculatedEditString = this.selectedMetricRow.CalculatedFormula;
            this.originalCalculatedFormula = this.selectedMetricRow.CalculatedFormula;
            this.firstCalculatedEdit = true;
            this.calculatedMetricModel = this.selectedMetricRow.CalculatedFormula;

            this.showCalculated = true;
            this.validationFlags.formulaInvalid = true;
            this.validationFlags.formulaEmpty = true;
        }
    }

    //This is the code to add the spans to the calculatedMetric readonly mode
    //I have to do a bunch of string manipulation to get it to work. 
    public calculatedMetricStringSetUp() {
        //first check and see if it is standard or calculated metric
        //cause if it's standard I don't want to do anything here
        if (this.selectedMetricRow.Type == MetricTypes.Calculated) {
            //this is where I do the string manipulation so I can highlight certain words
            let calculated = this.selectedMetricRow.CalculatedFormula;

            //my three strings that I append to the calculatedMetric
            let metricGreenHighlightOpening: string = `<span class="metricHighlight">`;
            let closingSpanTag: string = "</span>";
            let operandRedHightlightOpening: string = `<span class="operandHighlight">`;
            let bracketsColoring: string = `<span class="bracketHighlight">`;

            //have to do the operand first cause the string appending get's weird later on down
            for (let j = 0; j < calculated.length; j++) {
                if (calculated[j] == "/" || calculated[j] == "*" || calculated[j] == "+" || calculated[j] == "-" || calculated[j] == ">" || calculated[j] == "<" || calculated[j] == "=" || calculated[j] == "%" || calculated[j] == "^" || calculated[j] == ":" || calculated[j] == "(" || calculated[j] == ")") {
                    calculated = calculated.slice(0, j + 1) + closingSpanTag + calculated.slice(j + 1);

                    calculated = calculated.slice(0, j) + operandRedHightlightOpening + calculated.slice(j);

                    //I have to add this or it loops forever, which is bad, i've been told...
                    j += operandRedHightlightOpening.length + closingSpanTag.length;
                    continue;
                }
            }

            for (let i = 0; i < calculated.length; i++) {
                if (calculated[i] == "[") {
                    calculated = calculated.slice(0, i) + bracketsColoring + calculated.slice(i, i + 1) + closingSpanTag + metricGreenHighlightOpening + calculated.slice(i + 1);

                    i += bracketsColoring.length + closingSpanTag.length;
                    continue;
                }

                if (calculated[i] == "]") {
                    calculated = calculated.slice(0, i) + closingSpanTag + bracketsColoring + calculated.slice(i, i + 1) + closingSpanTag + calculated.slice(i + 1);

                    //the line aboves appends 7 characters so I need to skip over those or this will loop forever
                    i += closingSpanTag.length + bracketsColoring.length;
                    continue;
                }

                this.calculatedMetricHTML = calculated;

            }

            let variableCount = (this.calculatedMetricHTML.match(/{NUMDAYS}/g) || []).length;

            for (let i = 0; i < variableCount; i++) {
                this.calculatedMetricHTML = this.calculatedMetricHTML.replace("{NUMDAYS}", `<span class="variableHighlight">{NUMDAYS}</span>`);
            }

            this.calculatedMetricHTML = "<strong>" + this.calculatedMetricHTML + "</strong>";
        }
        else {
            return;
        }
    }

    public async deactivateMetric(metricID) {
        if (this.isActionRunning)
            return;
        else
            this.isActionRunning = true;

        await this.manageMetricsService.deactivateMetricDefinition(metricID);

        this.metricDefinitionsData = this.metricDefinitionsData.filter(item => {
            return item.MetricID != metricID;
        })

        this.agGrid?.api?.setGridOption('rowData', this.metricDefinitionsData);
        this.applyFilter();
        this.toastrManager.showToaster("success", this.localization.get('Metric_Deleted_Successful'));
        this.isActionRunning = false;
    }

    public CloseModal() {
        this.modalRef.close();
        this.assocMetricList = [];
    }

    public openAssignTool() {
        if (this.assignModal != null || !this.showCreateView)
            return;

        let assigned: CvCxEntities = {
            emp: [],
            rec: [],
            agentAttribute: [],
            login: []
        };

        this.assignments.forEach(e => {
            if (!!e.pointOfContactID)
                assigned.rec.push(this.pointsOfContact.get(e.pointOfContactID));
            else if (!!e.skillID)
                assigned.rec.push(this.skills.get(e.skillID));
            else if (!!e.campaignID)
                assigned.rec.push(this.campaigns.get(e.campaignID));
            else
                assigned.rec.push(this.companies.get(e.companyID));
        })

        let options: CvCxAssignToolOptions = {
            modalTitle: this.getLocalizationString("Metric_Assignments", "Metric Definition Assignments"),
            modalSaveLabel: this.getLocalizationString("Assign", "Assign"),
            modalCancelLabel: this.getLocalizationString("Cancel", "Cancel"),
            useBulkAdd: false,
            singleAdd: false,
            singleLevel: true,
            singleType: true,
            maxRecLevel: 4,
            showTypeValues: { emp: false, rec: true, agent_att: false, logins: false },
            assignedEntities: assigned
        };

        this.assignModal = this._dialogService.open(CvCxoneAssignToolComponent, {
            width: "1198px",
            height: "665px",
            baseZIndex: 10000,
            data: {
                options: options
            },
            styleClass: 'cx-one-ui btn-bg-is-white'
        });

        this.assignModal.onClose.pipe(first()).subscribe(this.onAssignToolClose.bind(this));
    }

    private onAssignToolClose(dto: CvCxAssignToolDTO) {
        if (dto != null) {
            this.selectedMetricRow.AssignmentIDs.splice(0);
            this.assignments.splice(0);
            this.selectedMetricRow.AssignAll = false;

            dto.assigned.rec.forEach(e => { this.selectedMetricRow.AssignmentIDs.push(e.GroupID); this.selectedMetricRow.Level = e.GroupLevel; });
            dto.selected.rec.forEach(e => {
                //check for new/updated companies
                if (e.GroupLevel == 4 && (!this.companies?.has(e.GroupID) ||  JSON.stringify(this.companies.get(e.GroupID)) !=  JSON.stringify(e))){
                    this.companies.set(e.GroupID, e);
                }
                //check for new/updated campaigns
                if (e.GroupLevel == 3 && (!this.campaigns?.has(e.GroupID) || JSON.stringify(this.campaigns.get(e.GroupID)) !=  JSON.stringify(e))){
                    this.campaigns.set(e.GroupID, e);
                }
                //check for new/updated skills
                if (e.GroupLevel == 2 && (!this.skills?.has(e.GroupID) || JSON.stringify(this.skills.get(e.GroupID)) !=  JSON.stringify(e))){
                    this.skills.set(e.GroupID, e);
                }
                //check for new/updated pointsOfContact
                if (e.GroupLevel == 1 && (!this.pointsOfContact?.has(e.GroupID) || JSON.stringify(this.pointsOfContact.get(e.GroupID)) !=  JSON.stringify(e))){
                    this.pointsOfContact.set(e.GroupID, e);
                }
                this.selectedMetricRow.AssignmentIDs.push(e.GroupID); 
                this.selectedMetricRow.Level = e.GroupLevel;
            });
        }

        if (this.selectedMetricRow.AssignmentIDs.length == 0 || this.selectedMetricRow.Level == 4) {
            this.selectedMetricRow.AssignAll = true;
        }

        this.assignModal = null;
        this.setupAssignments();
    }

    public removeSelectedAssignments() {
        if (!this.showCreateView || !this.agGridAssignments?.api)
            return;

        let selected: number[] = []
        this.agGridAssignments?.api.getSelectedRows().forEach(e => {
            if (this.selectedMetricRow.Level == 1)
                selected.push(e.pointOfContactID);
            else if (this.selectedMetricRow.Level == 2)
                selected.push(e.skillID);
            else if (this.selectedMetricRow.Level == 3)
                selected.push(e.campaignID);
            else if (this.selectedMetricRow.Level == 4)
                selected.push(e.companyID);
        });

        this.selectedMetricRow.AssignmentIDs = this.selectedMetricRow.AssignmentIDs.filter(f => {
            return !selected.includes(f);
        });
        this.setupAssignments();
        this.triggerCancelConfirm();
    }

    public onAssignmentsFilterChange(searchText) {
        this.agGridAssignments?.api.setGridOption('quickFilterText', searchText);
    }

    private async setupAssignments() {
        if (this.selectedMetricRow.Level == 0 || this.selectedMetricRow.Level == 4 || this.selectedMetricRow.AssignAll
            || this.selectedMetricRow.AssignmentIDs.length == 0) {
            if (this.selectedMetricRow.Level != 0 && this.selectedMetricRow.Level != 4)
                this.selectedMetricRow.Level = 4;

            this.selectedMetricRow.AssignAll = true;
        }

        this.buildAssignments();

        if (!!this.agGridAssignments?.api) {
            this.agGridAssignments?.api.setGridOption('headerHeight', (this.assignments.length > 0) ? 44 : 0);
            this.agGridAssignments?.api.setGridOption('columnDefs', [
                {
                    colId: "POC",
                    field: "pointOfContact",
                    headerName: this.getLocalizationStringUpper("POC", "POINT OF CONTACT"),
                    hide: this.selectedMetricRow.Level != 1,
                    headerCheckboxSelection: this.selectedMetricRow.Level == 1 && this.showCreateView,
                    checkboxSelection: this.selectedMetricRow.Level == 1 && this.showCreateView,
                },
                {
                    colId: "Skill",
                    field: "skill",
                    headerName: this.getLocalizationStringUpper("Skill", "SKILL"),
                    hide: this.selectedMetricRow.Level < 1 || this.selectedMetricRow.Level > 2,
                    headerCheckboxSelection: this.selectedMetricRow.Level == 2 && this.showCreateView,
                    checkboxSelection: this.selectedMetricRow.Level == 2 && this.showCreateView,
                },
                {
                    colId: "Campaign",
                    field: "campaign",
                    headerName: this.getLocalizationStringUpper("Campaign", "CAMPAIGN"),
                    hide: this.selectedMetricRow.Level < 1 || this.selectedMetricRow.Level > 3,
                    headerCheckboxSelection: this.selectedMetricRow.Level == 3 && this.showCreateView,
                    checkboxSelection: this.selectedMetricRow.Level == 3 && this.showCreateView,
                },
                {
                    colId: "Company",
                    field: "company",
                    headerName: this.getLocalizationStringUpper("Company", "COMPANY"),
                    hide: this.selectedMetricRow.Level < 1 || this.selectedMetricRow.Level > 4,
                    headerCheckboxSelection: this.selectedMetricRow.Level == 4 && this.showCreateView,
                    checkboxSelection: this.selectedMetricRow.Level == 4 && this.showCreateView,
                }
            ]);
            this.agGridAssignments?.api.setGridOption('rowData', []);
            this.agGridAssignments?.api.setGridOption('rowData', this.assignments);
        }
        else
            this.assignmentsGridOptions = this.getAssignmentsGridOptions();
    }

    private buildAssignments() {
        this.assignments.splice(0);

        this.selectedMetricRow.AssignmentIDs.forEach((id) => {
            let assignment: GroupAssignment = { companyID: 1, company: "" };
            let groupDTO: GroupDTO = null;

            switch (this.selectedMetricRow.Level) {
                case 1:
                    // Build out Points of Contact
                    if (this.pointsOfContact?.has(id)) {
                        groupDTO = this.pointsOfContact.get(id);
                        assignment.pointOfContactID = id;
                        assignment.pointOfContact = groupDTO.GroupName;

                        // Set id and fall through
                        id = groupDTO.ParentGroupID;
                    }
                    else
                        id = -1;
                case 2:
                    // Build out Skills
                    if (this.skills?.has(id)) {
                        groupDTO = this.skills.get(id);
                        assignment.skillID = id;
                        assignment.skill = groupDTO.GroupName;

                        // Set id and fall through
                        id = groupDTO.ParentGroupID;
                    }
                    else
                        id = -1;
                case 3:
                    // Build out Campaigns
                    if (this.campaigns?.has(id)) {
                        groupDTO = this.campaigns.get(id);
                        assignment.campaignID = id;
                        assignment.campaign = groupDTO.GroupName;

                        // Set id and fall through
                        id = groupDTO.ParentGroupID;
                    }
                    else id = -1;
                default:
                    // Build out Company
                    if (this.companies?.has(id)) {
                        groupDTO = this.companies.get(id);
                        assignment.companyID = id;
                        assignment.company = groupDTO.GroupName
                    }
            }

            this.assignments.push(assignment);
        });

        if (this.assignments.length > 5)
            this.assignmentsSize = "assignmentsGrid-lg";
        else
            this.assignmentsSize = "assignmentsGrid-sm";
    }

    private getAssignmentsGridOptions(): GridOptions {
        let gridOptions: GridOptions = {
            suppressRowClickSelection: true,
            suppressCellFocus: true,
            rowSelection: 'multiple',
            suppressMovableColumns: true,
            suppressContextMenu: true,
            rowClass: 'cxOneRow',
            rowHeight: 36,
            headerHeight: (this.assignments.length > 0) ? 44 : 0,
            defaultColDef: {
                flex: 1,
                sortable: true,
                resizable: false,
                suppressMenu: true,
                headerCheckboxSelectionFilteredOnly: true,
            },
            columnDefs: [
                {
                    colId: "POC",
                    field: "pointOfContact",
                    headerName: this.getLocalizationStringUpper("POC", "POINT OF CONTACT"),
                    hide: this.selectedMetricRow.Level != 1,
                },
                {
                    colId: "Skill",
                    field: "skill",
                    headerName: this.getLocalizationStringUpper("Skill", "SKILL"),
                    hide: this.selectedMetricRow.Level < 1 || this.selectedMetricRow.Level > 2,
                },
                {
                    colId: "Campaign",
                    field: "campaign",
                    headerName: this.getLocalizationStringUpper("Campaign", "CAMPAIGN"),
                    hide: this.selectedMetricRow.Level < 1 || this.selectedMetricRow.Level > 3,
                },
                {
                    colId: "Company",
                    field: "company",
                    headerName: this.getLocalizationStringUpper("Company", "COMPANY"),
                }
            ],
            overlayNoRowsTemplate: `<div class="error-container" style="padding-top: 44px; margin-top: 1rem;">
                                        <svg class="cxoneFavoriteState mb-2">
                                            <use href="../App_Themes/CXone/icons/empty-state.svg#empty-state"></use>
                                        </svg>
                                        <p class="cxone-error-text">${this.cvLocalizationFactory.getCachedText("CXOne_Manage_Metrics", "No_Group_Assigned", "No group assigned yet")}</p>
                                    </div>`,
            onGridReady: (params) => {
                this.agGridAssignments.api.setGridOption('rowData', []);
                this.agGridAssignments.api.setGridOption('rowData', this.assignments);
            },
            onRowDataUpdated: (event: RowDataUpdatedEvent) => {
                this.updateAssignmentsLabel(event.api);
            },
            onFilterChanged: (event) => {
                this.updateAssignmentsLabel(event.api);
            }
        };

        if (this.showCreateView)
            for (let i = 0; i < gridOptions.columnDefs.length; ++i) {
                if ((gridOptions.columnDefs[i] as ColDef).hide)
                    continue;
                (gridOptions.columnDefs[i] as ColDef).headerCheckboxSelection = true;
                (gridOptions.columnDefs[i] as ColDef).checkboxSelection = true;
                break;
            }

        return gridOptions;
    }

    private updateAssignmentsLabel(api: GridApi) {
        let assignmentLabel = "";
        let assignmentCount = api.getDisplayedRowCount();
        let singluar: boolean = assignmentCount == 1;
        switch (this.selectedMetricRow.Level) {
            case 1:
                assignmentLabel = singluar ? this.getLocalizationString('POC', 'Point of Contact') : this.getLocalizationString('Pocs', 'Points of Contact');
                this.assignmentsSearchPlaceholder = this.getLocalizationString('Poc_Search', 'Search for points of contacts');
                break;
            case 2:
                assignmentLabel = singluar ? this.getLocalizationString('Skill', 'Skill') : this.getLocalizationString('Skills', 'Skills');
                this.assignmentsSearchPlaceholder = this.getLocalizationString('Skill_Search', 'Search for skills');
                break;
            case 3:
                assignmentLabel = singluar ? this.getLocalizationString('Campaign', 'Campaign') : this.getLocalizationString('Campaigns', 'Campaigns');
                this.assignmentsSearchPlaceholder = this.getLocalizationString('Campaign_Search', 'Search for campaigns');
                break;
            case 4:
                if (this.assignments.length > 0) {
                    assignmentLabel = singluar ? this.getLocalizationString('Company', 'Company') : this.getLocalizationString('Companies', 'Companies');
                    this.assignmentsSearchPlaceholder = this.getLocalizationString('Companies_Search', 'Search for companies');
                    break;
                }
            default:
                assignmentLabel = this.getLocalizationString('Groups', 'Groups');
                this.assignmentsSearchPlaceholder = this.getLocalizationString('Search', 'Search...');
        }
        if (assignmentLabel != "")
            this.assignmentsLabel = `${assignmentCount} ${assignmentLabel}`;
        else
            this.assignmentsLabel = assignmentLabel;

        if (api.getDisplayedRowCount() == 0)
            api.showNoRowsOverlay();
        else
            api.hideOverlay();
    }

    public createMetric() {
        if(this.hasPMLicense){
            this.selectedMetricRow = this.setupNewMetricObject();
            this.origSelectedMetricRow = cloneDeep(this.selectedMetricRow);
            this.showCreateView = true;
            this.showDetailView = false;
            this.isDisabled = false;
            this.isEditingDisabled = false;
            this.isNewMetric = true;

            this.setupAssignments();

            this.setCategoryOptions();

            this.setAggregationOptions();
            this.setFormatOptions(); //has short circuit check if already filled
            this.setTimeTypeOptions();

            this.selectedRadioValue = "0";
            this.selectedCategoryValue = null;
            this.selectedAggregationValue = null;
            this.selectedFormatValue = null;
            this.selectedTimeValue = null;
            this.selectedReportingSet = null;
            this.selectedMetricDate = null;
            this.selectedMetricDates = [];
            this.selectedDefaultDate = null;
            this.selectedEndDate = null;
            this.selectedDataValue = null;
            this.metricValue = "Data field";

            this.metricDateOptions = [];
            this.dataValueOptions = [];
            this.defaultDateOptions = [];

            if(this.reportingSets == null)
                this.getConfigurationData();
                this.getSetRecGroup();

            this.setGroupValues();

            this.metricTypeOptions = [{ name: this.localization.get("Metric_Type_Calculated"), value: 1 }, { name: this.localization.get("Metric_Type_Standard"), value: 2 }];

            this.resetValidationFlags();
            this.validateMetricName();
        }
        else{
            let modal = document.getElementById("PMLicenseModalNewMetric") as HTMLElement;
            modal.style.display = (modal.style.display === 'block') ? 'none' : 'block';
        }
    }

    public resetValidationFlags() {
        this.validationFlags = {
            nameExists: true,
            nameUnique: true,
            nameLength: true,
            nameChars: true,
            category: true,
            aggregation: true,
            format: true,
            direction: true,
            description: true,
            reportingSet: true,
            metricDate: true,
            metricDataValue: true,
            metricEndDate: true,
            formulaEmpty: true,
            formulaInvalid: true,
            formulaOperator: true,
            formulaInvalidMetric: true,
            formulaSpecialCharacter: true,
            formulaMissingMetric: true,
            displayCalculatedErrorMessage: false,
            aggregationChanged: false,
            formatTypeChanged: false,
            metricDateChanged: false,
            addFiltersChanged: false,
            metricDataValueChanged: false,
            metricEndDateChanged: false,
            metricNameChanged: false,
            rootMetricBeingUsedInFormula: true,
            templatePlaceholder: false,
        };
    }

    public setupNewMetricObject() {
        let newObj = {
            _id: null,
            Abreviation: "",
            Active: true,
            AggregationType: null,
            AssignAll: true,
            AssignmentIDs: [],
            CalculatedFormula: undefined,
            Components: [],
            Direction: 0,
            EmpLevelMin: 1,
            Group: "",
            IsEditable: true,
            Level: 0,
            MetricDescription: "",
            MetricID: 0,
            MetricImageID: 0,
            MetricName: "",
            NumericType: null,
            RecLevelMin: 1,
            ShowInSelector: true,
            Status: { IsValid: true, ConsecutiveFailureCount: 0, LastSuccessDate: null },
            TimeFormat: TimeFormat.None,
            Type: undefined //MetricTypes.Standard
        } as MetricDefinition;
        return newObj;
    }

    public async confirmDashboardDelete(metric: MetricDefinition) {
        let hasAssocMetric: boolean = false;
        this.selectedMetric = metric;

        //Check if the metric has any others associated with it
        hasAssocMetric = this.metricDefinitionsData.some(item => {
            return item.CalculatedFormula?.includes(']' + metric.MetricID + '#');
        })

        //Create a list of all associated metrics
        this.assocMetricList = this.metricDefinitionsData.filter(item => {
            return item.CalculatedFormula?.includes(']' + metric.MetricID + '#');
        })

        if (hasAssocMetric) {
            this.modalRef = this.modalService.open(this.assocMetricModal, {
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                modalDialogClass: 'cx-one-ui modal-center'
            });
        }
        else {
            this.manageMetricsService.popoverObj.open();
        }
    }

    public async ChangeReportingSet(e) {
        if(this.reportingSets == null)
            await this.getConfigurationData();
            await this.getSetRecGroup();    

        this.metricDateOptions = [];
        this.selectedMetricDates = [];
        this.selectedMetricDate = null;
        this.selectedDefaultDate = null;
        this.selectedEndDate = null;
        this.selectedDataValue = null;
        this.selectedReportingSet = this.reportingSets.find((item) => { return item._id == e.value });
        this.reportingSetCurrent = { name: this.selectedReportingSet?.ReportingSetName, value: this.selectedReportingSet?._id };
        Object.keys(this.selectedReportingSet.Dates).forEach((item) => { this.metricDateOptions.push({ name: item }) });
        this.dataValueOptions = [];
        this.defaultDateOptions = [];
        Object.keys(this.selectedReportingSet?.DataFields).forEach((item) => {
            if(this.selectedReportingSet?.DataFields[item].ExpectedType == 1 || this.selectedReportingSet?.DataFields[item].ExpectedType == 2)
                this.dataValueOptions.push({ name: item }); 
        });
        this.selectedMetricRow.Components[0].ReportingSetName = this.selectedReportingSet.ReportingSetName;
        this.selectedMetricRow.Components[0].FilterFields = [];
        this.selectedMetricRow.Components[0].StartDate = null;
        this.selectedMetricRow.Components[0].DataValue = null;
        this.selectedMetricRow.Components[0].EndDate = null;

        this.selectedMetricRow.QueuedOnImport = this.selectedReportingSet.QueuedOnImport;
        this.validateReportingSetInfo()
        await this.isMetricDefinitionValid();
    }

    public getComparisonOperator(comparisonType: ComparisonType) {
        return this.manageMetricsService.getDisplayComparisonTypes(comparisonType, this.localization);
    }

    public async updateMetricDates(e) {
        this.selectedMetricDates = e;
        this.defaultDateOptions = this.selectedMetricDates.map(item => ({ name: item.name }));
        // Set DateFields IFF we have multiple metric dates selected, otherwise set to empty list.
        this.selectedMetricRow.Components[0].DateFields = (this.defaultDateOptions.length > 1)
            ? this.defaultDateOptions.map(item => item.name)
            : [];
        if (!this.defaultDateOptions.some(item => item.name == this.selectedDefaultDate?.name)){
            this.selectedDefaultDate = null;
            this.selectedMetricRow.Components[0].StartDate = null;
        }
        this.validateReportingSetInfo();
        this.validationFlags.metricDateChanged = true;
        await this.isMetricDefinitionValid();
    }

    public async updateMetricStartDate(e) {
        if (this.selectedReportingSet?.IsApiSourced) {
            this.selectedDefaultDate = e;
            this.selectedMetricRow.Components[0].StartDate = this.selectedDefaultDate.name;
        }
        else {
            this.selectedMetricDate = e;
            this.selectedMetricRow.Components[0].StartDate = this.selectedMetricDate.name;
        }
        this.validateReportingSetInfo();
        this.validationFlags.metricDateChanged = true;
        await this.isMetricDefinitionValid();
    }

    public async updateMetricDataValue(e) {
        this.selectedDataValue = e;
        this.selectedMetricRow.Components[0].DataValue = this.selectedDataValue.name;
        this.validateReportingSetInfo();
        this.validationFlags.metricDataValueChanged = true;
        await this.isMetricDefinitionValid();
    }

    public async updateMetricEndDate(e) {
        this.selectedEndDate = e;
        this.selectedMetricRow.Components[0].EndDate = this.selectedEndDate.name;
        this.validateReportingSetInfo();
        this.validationFlags.metricEndDateChanged = true;
        await this.isMetricDefinitionValid();
    }

    public async updateMetricValue() {

        if (this.metricValue == "Count") {
            this.selectedMetricRow.Components[0].IsCount = true;
            this.selectedMetricRow.Components[0].IsTime = false;
        }
        else if (this.metricValue == "Time") {
            this.selectedMetricRow.Components[0].IsCount = false;
            this.selectedMetricRow.Components[0].IsTime = true;
        }
        else { // Data Field
            this.selectedMetricRow.Components[0].IsCount = false;
            this.selectedMetricRow.Components[0].IsTime = false;
        }

        this.selectedEndDate = null;
        this.selectedDataValue = null;
        this.selectedMetricRow.Components[0].EndDate = null;
        this.selectedMetricRow.Components[0].DataValue = null;

        this.validateReportingSetInfo();
        this.validationFlags.metricDateChanged = true;
        await this.isMetricDefinitionValid();
    }

    public CheckIfNumber(input: string) {
        return isNaN(Number(input)) ? `"${input}"` : input;
    }

    public showMessageModal() {
        if (!this.cancelMessageModalRef) {
            const dialogData = {
                title: this.getLocalizationString('Edit_Cancel_Confirmation_Header', "Leave?"),
                type: 'user-warning', //MessageTypes from cxone-components/modal
                message: this.getLocalizationString('Lose_Changes', "All changes will be lost."),
                primaryButtonText: this.getLocalizationString('Edit_Cancel_Confirmation_Primary', "Leave"),
                closeButtonText: this.getLocalizationString('Edit_Cancel_Confirmation_Secondary', "Stay")
            };
            this.cancelMessageModalRef = this._dialogService.open(MessageModalComponent, {
                width: '420px',
                height: '184px',
                data: dialogData,
                styleClass: "cx-one-ui"
            });

            this.cancelMessageModalRef.onClose.subscribe(value => {
                if (value)
                    this.backClick();
                this.cancelMessageModalRef = null;
            });
        }


    }

    public async getMetricConfigurationData() {
        if(this.reportingSets == null)
            await this.getConfigurationData();

        if (this.selectedMetricRow.Type == MetricTypes.Standard) {
            if (this.selectedMetricRow.Components[0].IsCount) {
                this.metricValue = "Count";
            }
            else if (this.selectedMetricRow.Components[0].IsTime) {
                this.metricValue = "Time"
            }
            else {
                this.metricValue = "Data field"
            }

            this.metricDateOptions = [];
            this.dataValueOptions = [];
            let dateFields = this.selectedMetricRow.Components[0].DateFields || [];
            this.selectedMetricDates = dateFields.length > 0 ? dateFields.map(item => { return { name: item } }) : [{ name: this.selectedMetricRow.Components[0]?.StartDate }];
            this.defaultDateOptions = this.selectedMetricDates.map(item => { return { name: item.name } });

            this.selectedReportingSet = this.reportingSets?.find((item) => { return item?.ReportingSetName == this.selectedMetricRow?.Components[0]?.ReportingSetName });
            this.reportingSetCurrent = { name: this.selectedReportingSet?.ReportingSetName, value: this.selectedReportingSet?._id };
            if (this.selectedReportingSet !== undefined) {
                Object.keys(this.selectedReportingSet?.Dates).forEach((item) => { this.metricDateOptions.push({ name: item }) });
                Object.keys(this.selectedReportingSet?.DataFields).forEach((item) => {
                    if(this.selectedReportingSet?.DataFields[item].ExpectedType == 1 || this.selectedReportingSet?.DataFields[item].ExpectedType == 2)
                        this.dataValueOptions.push({ name: item }); 
                });
            }
            this.selectedDefaultDate = { name: this.selectedMetricRow.Components[0]?.StartDate };
            this.selectedMetricDate = { name: this.selectedMetricRow.Components[0]?.StartDate };
            this.selectedEndDate = { name: this.selectedMetricRow.Components[0]?.EndDate };
            this.selectedDataValue = { name: this.selectedMetricRow.Components[0]?.DataValue };

        }
    }

    public OpenFilterModal() {
        this.modalRef = this.modalService.open(this.filterFieldsModal, {
            backdrop: 'static',
            keyboard: false,
            size: 'lg',
            modalDialogClass: 'cx-one-ui modal-center-filter'
        });
        this.validationFlags.addFiltersChanged = true;
    }

    public isMetricChanged(): boolean {

        //new logic requirements
        //all required fields must be selected first, then standard change detection

        if (this.selectedMetricRow.Type == MetricTypes.Standard) {
            let startDate = this.selectedMetricRow.Components[0].StartDate ?? "";
            let dateFields = this.defaultDateOptions ?? [];
            if (this.selectedReportingSet == null || startDate == null || startDate == "") {
                return false;
            }
            if (this.selectedReportingSet.IsApiSourced && (dateFields == null || dateFields.length == 0)){
                return false;
            }

            if (this.metricValue == "Time") {
                let endDate = this.selectedMetricRow.Components[0].EndDate ?? "";
                if (endDate == null || endDate == "") {
                    return false;
                }
            }
            if (this.metricValue == "Data field") {
                let dataValue = this.selectedMetricRow.Components[0].DataValue;
                if (dataValue == null || dataValue == "") {
                    return false;
                }
            }
        }


        if (this.selectedMetricRow.MetricName == null || this.selectedMetricRow.MetricName == "" ||
            this.validationFlags.nameUnique == false || this.validationFlags.nameChars == false || this.validationFlags.nameLength == false ||
            this.selectedMetricRow.Group == null || this.selectedMetricRow.Group == "" || this.selectedMetricRow.Group.length > 50 ||
            this.selectedMetricRow.Direction < 0 || this.selectedMetricRow.Direction > 1 ||
            this.selectedMetricRow.AggregationType == null || this.selectedMetricRow.NumericType == null ||
            (this.selectedMetricRow.NumericType == 3 && (this.selectedMetricRow.TimeFormat != TimeFormat.Second && this.selectedMetricRow.TimeFormat != TimeFormat.Minute && this.selectedMetricRow.TimeFormat != TimeFormat.Hour && this.selectedMetricRow.TimeFormat != TimeFormat.Time)) ||
            this.selectedMetricType == null) {

            return false;
        }
        else {
            if (this.selectedMetricRow.Type == MetricTypes.Standard) {
                let origComp = this.origSelectedMetricRow.Components[0];
                let newComp = this.selectedMetricRow.Components[0];

                if (origComp?.IsCount != newComp.IsCount ||
                    origComp?.StartDate != newComp.StartDate ||
                    origComp?.DateFields != newComp.DateFields ||
                    origComp?.EndDate != newComp.EndDate ||
                    origComp?.DataValue != newComp.DataValue ||
                    origComp?.IsTime != newComp.IsTime ||
                    JSON.stringify(origComp?.FilterFields) != JSON.stringify(newComp.FilterFields) ||
                    origComp?.ReportingSetGroup != newComp.ReportingSetGroup ||
                    origComp?.ReportingSetName != newComp.ReportingSetName ||
                    origComp?.IsPositive != newComp.IsPositive ||
                    JSON.stringify(origComp?.AttributeFields) != JSON.stringify(newComp.AttributeFields)
                )
                    return true;
            }

            if (this.selectedMetricRow.Type == MetricTypes.Calculated) {
                this.getCalculatedFormula();
            }

            if (this.selectedMetricRow.Type == MetricTypes.Calculated && this.selectedMetricRow.CalculatedFormula == "")
                return false;

            
            //Sort the assignment IDs so that they will be in the same positions
            let origArray = this.origSelectedMetricRow.AssignmentIDs.sort((a, b) => a - b);
            let newArray = this.selectedMetricRow.AssignmentIDs.sort((a, b) => a - b);

            //Check if the arrays match
            let assignmentMatch = JSON.stringify(origArray) == JSON.stringify(newArray);


            //check if changes are present
            if (this.origSelectedMetricRow.MetricName.trim().replace(/\s+/g, ' ') != this.selectedMetricRow.MetricName.trim().replace(/\s+/g, ' ') ||
                this.origSelectedMetricRow.MetricDescription != this.selectedMetricRow.MetricDescription ||
                this.origSelectedMetricRow.EmpLevelMin != this.selectedMetricRow.EmpLevelMin ||
                this.origSelectedMetricRow.RecLevelMin != this.selectedMetricRow.RecLevelMin ||
                this.origSelectedMetricRow.Group != this.selectedMetricRow.Group ||
                this.origSelectedMetricRow.Direction != this.selectedMetricRow.Direction ||
                this.origSelectedMetricRow.AggregationType != this.selectedMetricRow.AggregationType ||
                this.origSelectedMetricRow.NumericType != this.selectedMetricRow.NumericType ||
                this.origSelectedMetricRow.TimeFormat != this.selectedMetricRow.TimeFormat ||
                this.origSelectedMetricRow.ShowInSelector != this.selectedMetricRow.ShowInSelector ||
                this.origSelectedMetricRow.CalculatedFormula != this.selectedMetricRow.CalculatedFormula ||
                this.origSelectedMetricRow.Level != this.selectedMetricRow.Level ||
                assignmentMatch != true) {
                return true;
            }

            return false;
        }
    }

    public triggerCancelConfirm(): boolean {
        if(this.origSelectedMetricRow == null)
            return false;

        let assignmentMatch: boolean = true;
        if (this.origSelectedMetricRow.AssignAll != this.selectedMetricRow.AssignAll)
            assignmentMatch = false;
        if (this.origSelectedMetricRow.AssignmentIDs.length != this.selectedMetricRow.AssignmentIDs.length)
            assignmentMatch = false;

        if (assignmentMatch) {
            for (var i = 0; i < this.origSelectedMetricRow.AssignmentIDs.length; i++) {
                assignmentMatch = false;

                for (var j = 0; j < this.selectedMetricRow.AssignmentIDs.length; j++) {
                    if (this.origSelectedMetricRow.AssignmentIDs[i] == this.selectedMetricRow.AssignmentIDs[j]) {
                        assignmentMatch = true;
                        break;
                    }
                }

                if (!assignmentMatch)
                    break;
            }
        }

        //check if changes are present
        if (this.origSelectedMetricRow.MetricName == this.selectedMetricRow.MetricName &&
            this.origSelectedMetricRow.MetricDescription == this.selectedMetricRow.MetricDescription &&
            this.origSelectedMetricRow.EmpLevelMin == this.selectedMetricRow.EmpLevelMin &&
            this.origSelectedMetricRow.RecLevelMin == this.selectedMetricRow.RecLevelMin &&
            this.origSelectedMetricRow.Group == this.selectedMetricRow.Group &&
            this.origSelectedMetricRow.Direction == this.selectedMetricRow.Direction &&
            this.origSelectedMetricRow.AggregationType == this.selectedMetricRow.AggregationType &&
            this.origSelectedMetricRow.NumericType == this.selectedMetricRow.NumericType &&
            this.origSelectedMetricRow.TimeFormat == this.selectedMetricRow.TimeFormat &&
            this.origSelectedMetricRow.ShowInSelector == this.selectedMetricRow.ShowInSelector &&
            this.origSelectedMetricRow.CalculatedFormula == this.selectedMetricRow.CalculatedFormula &&
            this.origSelectedMetricRow.Level == this.selectedMetricRow.Level &&
            JSON.stringify(this.origSelectedMetricRow.Components) == JSON.stringify(this.selectedMetricRow.Components) &&
            this.origSelectedMetricRow.Type == this.selectedMetricRow.Type &&
            assignmentMatch == true){
                sendMessageCXOne({ hasNonSavedChanges: false });
                return false;
            }
            
        sendMessageCXOne({ hasNonSavedChanges: true });
        return true;
    }

    public async isMetricDefinitionValid(): Promise<boolean> { //fire this as part of save click
        //fire all validations first so all flags will be set rather than just the first to fail
        this.validateMetricName();
        this.validateCategory();
        this.validateMetricDescription();
        this.validateAggregationType();
        this.validateFormatType();
        this.validateReportingSetInfo();

        if (this.validationFlags.nameExists == false || this.validationFlags.nameChars == false || this.validationFlags.nameLength == false || this.validationFlags.nameUnique == false)
            return false;

        if (this.validationFlags.category == false)
            return false;   //group value is required and must be less than 50 length

        if (this.validationFlags.description == false)
            return false;   //description value must be less than 1000 length

        if (this.selectedMetricRow.Direction != 0 && this.selectedMetricRow.Direction != 1)
            return false; //somehow they got a direction other than up or down so disallow

        if (this.validationFlags.aggregation == false)  //aggregation type must be non null
            return false

        if (this.groupTypes != null) {
            if (this.selectedMetricRow.EmpLevelMin == null || this.selectedMetricRow.EmpLevelMin < 1 || this.selectedMetricRow.EmpLevelMin > this.groupTypes.emp.length)
                return false;

            if (this.selectedMetricRow.RecLevelMin == null || this.selectedMetricRow.RecLevelMin < 1 || this.selectedMetricRow.RecLevelMin > this.groupTypes.rec.length)
                return false;
        }

        if (this.validationFlags.format == false)
            return false;
        else if (this.selectedMetricRow.NumericType == NumericType.Time) {
            switch (this.selectedMetricRow.TimeFormat) {
                case TimeFormat.Second:
                case TimeFormat.Minute:
                case TimeFormat.Hour:
                case TimeFormat.Time:
                    break;
                default:
                    return false;
            }
        }

        //TODO: readd when metric type options are available
        if (this.selectedMetricType == null || (this.selectedMetricRow.Type != MetricTypes.Calculated && this.selectedMetricRow.Type != MetricTypes.Standard))
            return false;

        if (this.selectedMetricRow.Type == MetricTypes.Standard) { //standard


            if (!this.validationFlags.metricDataValue || !this.validationFlags.metricDate || !this.validationFlags.reportingSet)
                return false;

            if (this.metricValue == "Time") {
                if (!this.validationFlags.metricEndDate) {
                    return false;
                }
            }
        }
        else if (this.selectedMetricRow.Type == MetricTypes.Calculated) { //calculated
            //TODO finish calculated validtion check
            this.calculatedMetricHTML = this.selectedMetricRow.CalculatedFormula;

            await this.validateFormula();
            if(this.validationFlags.formulaInvalid == false || this.validationFlags.formulaEmpty == false || this.validationFlags.formulaInvalidMetric == false || this.validationFlags.formulaMissingMetric == false || this.validationFlags.formulaOperator == false || this.validationFlags.formulaSpecialCharacter == false || this.validationFlags.rootMetricBeingUsedInFormula == false){
                return false;
            }
        }

        //TODO Add check for Assignments section
        //check for Null and cases?

        return true;
    }

    public AddFilterButtonIsValid(): boolean {

        this.validateMetricName();
        this.validateCategory();
        this.validateMetricDescription();
        this.validateAggregationType();
        this.validateFormatType();
        this.validateReportingSetInfo();

        if (this.selectedMetricRow.Type == MetricTypes.Standard) { //standard

            if (!this.validationFlags.reportingSet || !this.validationFlags.metricDate ||
                !this.validationFlags.category || !this.validationFlags.aggregation || !this.validationFlags.format ||
                !this.validationFlags.nameExists || !this.validationFlags.nameLength || !this.validationFlags.nameUnique || !this.validationFlags.nameChars) {
                return false;
            }

            if (this.metricValue == "Time") {
                if (!this.validationFlags.metricEndDate) {
                    return false;
                }
            }
            else if (this.metricValue == "Data field") {
                if (!this.validationFlags.metricDataValue) {
                    return false;
                }
            }

            return true;

        }
    }

    public async contextMenuRecalculationClick(definition) {
        this.inProgressMetricList = await this.getInProgressRecalculation();
        this.selectedMetricRow = cloneDeep(definition);
        this.origSelectedMetricRow = cloneDeep(definition);
        const dialogRef = this._dialogService.open(ManageMetricsRecalculationModalComponent, {
            width: "756px",
            height: "586px",
            styleClass: 'cx-one-ui modal-center',
            data: {
                metricsId: this.selectedMetricRow.MetricID,
                isRecalculationOption: true,
                metricsInProgress: this.inProgressMetricList
            }
        });
        dialogRef.onClose.subscribe(async data => {
            if (data) {
                await this.recalculationStatus();
                try {
                    this.timer = setInterval(async () => {
                        if (this.recalculatingMetrics?.size === 0) {
                            clearInterval(this.timer);
                        } else {
                            await this.recalculationStatus();
                        }
                    }, this.intervalTime);
                } catch (error) {
                    if (this.timer) {
                        clearInterval(this.timer);
                    }
                }
            }
            this.backClick();
        });
    }
    
    metricNameChanged(event) {
        this.validateMetricName();
        this.updateAbbrev(event);
        this.triggerCancelConfirm();
        this.isMetricNameChanged = true;
    }
    
    public async saveClicked() {
        if (this.showSpinner)
            return;

        const shouldOpenModal = (
            this.validationFlags.aggregationChanged ||
            this.validationFlags.formatTypeChanged ||
            this.validationFlags.metricDateChanged ||
            this.validationFlags.addFiltersChanged ||
            this.validationFlags.metricDataValueChanged ||
            this.validationFlags.metricEndDateChanged ||
            this.validationFlags.metricNameChanged
        );

        if (this.selectedMetricRow.Type == MetricTypes.Calculated) {
            //this is to get the calculated sign on the ag-grid
            this.getCalculatedFormula();
            this.selectedMetricRow.Type = 2;
        }

        this.selectedMetricRow.MetricName = this.selectedMetricRow.MetricName.trim().replace(/\s+/g, ' ');
        let origMetricID = this.selectedMetricRow.MetricID;

        if ((this.isDuplicate || shouldOpenModal || this.isMetricNameChanged) && this.selectedMetricRow.Type === MetricTypes.Standard) {
            let result = await this.isMetricDefinitionValid();
            if(result){
                this.openRecalculationModal(result);
                this.isMetricNameChanged = false;
            }
        } else {
            let result = await this.isMetricDefinitionValid();
            if(result){
                this.showSpinner = true;
                await this.saveData(result);
                this.showToaster(this.isDuplicate);
                this.backClick();
            }
        }
        this.showSpinner = false;
    }

    public async saveData(result: any, recalculateOnDuplicate?: boolean) {
        if (result) {
            try {
                let saveMetricResponse = await this.manageMetricsService.postSaveMetricDefinition(this.selectedMetricRow);
                if (saveMetricResponse && saveMetricResponse.Validation == MetricDefinitionValidation.Success) {
                    sendMessageCXOne({ hasNonSavedChanges: false });
                    this.originalCalculatedFormula = "";

                    let dataPulls = 0;
                    let checkMetrics = false;
                    let newlyRetrievedMetric: MetricDefinition;

                    //The backend sometimes doesn't save fast enough so this is a workaround to make sure the metric is saved before we try to retrieve it and repopulate the table
                    while (!checkMetrics) {
                        dataPulls++;
                        this.metricDefinitionsData = await this.manageMetricsService.getMetricDefinitions();

                        if (this.selectedMetricRow && this.selectedMetricRow.MetricName) {
                            newlyRetrievedMetric = this.metricDefinitionsData.find(metric => metric.MetricName == this.selectedMetricRow.MetricName);
                        } else if (this.selectedMetricRow && this.selectedMetricRow.MetricID) {
                            newlyRetrievedMetric = this.metricDefinitionsData.find(metric => metric.MetricID == this.selectedMetricRow.MetricID);
                        }

                        if (recalculateOnDuplicate && newlyRetrievedMetric) {
                            this.selectedMetricRow = newlyRetrievedMetric;
                        }

                        checkMetrics = this.areMetricsSame(newlyRetrievedMetric, this.selectedMetricRow);

                        if (dataPulls > 10) {
                            break;
                        }
                    }
                    this.agGrid?.api?.setGridOption('rowData', this.metricDefinitionsData);
                    this.curMetricCount = this.metricDefinitionsData.length;
                    if (this.searchValue !== '') {
                        this.applyFilter();
                    }
                    setTimeout(() => {
                        this.agGrid?.api.redrawRows();
                    }, 500);
                }
            } catch (ex) {
                console.error("Error saving Metric Definition:", ex);
                // Display error dialog to the user with the ApiResponse warnings as the content (if available)
                let message = "Unknown error.";
                let response = ex as ApiResponse<SaveMetricResponse>;
                if (response?.status_code != null) {
                    message = `Status code: ${response.status_code}`;
                    if (Array.isArray(response?.warnings)) {
                        response.warnings.forEach(w => {
                            console.error(w);
                            // htmlEncode() is in ClearView WebPortal/Scripts/Utilities.js
                            //let sanitizedWarning: string = window["htmlEncode"](w);
                            //message += `<li>${sanitizedWarning}</li>`;
                        });
                    }
                }
            }
        }
    }

    public showToaster(isDuplicate: boolean = false) {
        if (isDuplicate) {
            this.toastrManager.showToaster("success", this.getLocalizationString('Metric_Duplicated_Successful', "Metric duplicated successfully."));
        } else if (this.selectedMetricRow.MetricID === 0) {
            this.toastrManager.showToaster("success", this.getLocalizationString('Metric_Created_Successful', "Metric created successfully."));
        } else {
            this.toastrManager.showToaster("success", this.getLocalizationString('Metric_Updated_Successful', "Metric updated successfully."));
        }
    }
    public openRecalculationModal(validMetricResult?: boolean): void {
        this.isRecalculationModalOpen = true
        const dialogData = {
            title: this.getLocalizationString("Recalculate_Metrics", "Recalculate Metrics"),
            type: 'user-warning',
            message: this.getLocalizationString("Recalculate_Metrics_Message", 'Would you like to recalculate the metric "'+ this.selectedMetricRow.MetricName + '"?'),
            primaryButtonText: this.getLocalizationString("Yes", "Yes"),
            closeButtonText: this.getLocalizationString("No", "No")
        };
        const dialogRef = this._dialogService.open(MessageModalComponent, {
            width: '420px',
            height: '184px',
            styleClass: 'cx-one-ui modal-center',
            data: dialogData
        });

        dialogRef.onClose.subscribe(async result => {
            if (result) {
                await this.saveData(validMetricResult, true);
                this.inProgressMetricList = await this.getInProgressRecalculation();
                const recalculationDialogRef = this._dialogService.open(ManageMetricsRecalculationModalComponent, {
                    width: '756px',
                    height: '586px',
                    styleClass: 'cx-one-ui modal-center',
                    data: {
                        metricsId: this.selectedMetricRow.MetricID,
                        metricsInProgress: this.inProgressMetricList,
                        hideMetricsUpdatedToaster: true
                    }
                });
                recalculationDialogRef.onClose.subscribe(async recalculationResult => {
                    this.showToaster(this.isDuplicate);
                    if (recalculationResult) {
                        await this.recalculationStatus();
                        try {
                            this.timer = setInterval(async () => {
                                if (this.recalculatingMetrics?.size === 0) {
                                    clearInterval(this.timer);
                                } else {
                                    await this.recalculationStatus();
                                }
                            }, this.intervalTime);
                        } catch (error) {
                            if (this.timer) {
                                clearInterval(this.timer);
                            }
                        }
                    }
                    this.backClick();
                });
            } else {
                this.isRecalculationModalOpen = false;
                await this.saveData(validMetricResult);
                this.showToaster(this.isDuplicate);
                this.backClick();
            }
        });
    }

    public editFilterFieldsAddClick(newFilters: FilterValue[]) {
        this.selectedMetricRow.Components[0].FilterFields = newFilters;
        this.triggerCancelConfirm();
        this.modalRef.close();
    }

    public calculatedMetricConcat(value: number) {
        if (this.ed == null) {
            this.ed = tinymce.activeEditor;
        }

        let insertString = "";
        if (value == 0) {
            this.insertIntoTinyMCE("+");
        }
        else if (value == 1) {
            this.insertIntoTinyMCE("-");
        }
        else if (value == 2) {
            this.insertIntoTinyMCE("*");
        }
        else if (value == 3) {
            this.insertIntoTinyMCE("/");
        }
        else if (value == 4) {
            this.insertIntoTinyMCE(">");
        }
        else if (value == 5) {
            this.insertIntoTinyMCE("<");
        }
        else if (value == 6) {
            this.insertIntoTinyMCE("=");
        }
        else if (value == 7) {
            this.insertIntoTinyMCE("%");
        }
        else if (value == 8) {
            this.insertIntoTinyMCE("^");
        }
        else if (value == 9) {
            this.insertIntoTinyMCE(":");
        }
        else if (value == 10) {
            insertString = "( )"

            for (let char of insertString) {
                this.insertIntoTinyMCE(char);
            }
        }
        else if (value == 11) {
            insertString = "abs(x)"

            for (let char of insertString) {
                this.insertIntoTinyMCE(char);
            }
        }
        else if (value == 12) {
            insertString = "sqrt(x)"

            for (let char of insertString) {
                this.insertIntoTinyMCE(char);
            }
        }
        else if (value == 13) {
            insertString = "rem(x,n)"

            for (let char of insertString) {
                this.insertIntoTinyMCE(char);
            }
        }
        else if (value == 14) {
            insertString = "pow(x,n)"

            for (let char of insertString) {
                this.insertIntoTinyMCE(char);
            }
        }
        else if (value == 15) {
            insertString = "log(x)"

            for (let char of insertString) {
                this.insertIntoTinyMCE(char);
            }
        }
        else if (value == 16) {
            insertString = "round(x)"

            for (let char of insertString) {
                this.insertIntoTinyMCE(char);
            }
        }
        else if (value == 17) {
            insertString = "truncate(x)"

            for (let char of insertString) {
                this.insertIntoTinyMCE(char);
            }
        }
        else if (value == 18) {
            insertString = "floor(x)"

            for (let char of insertString) {
                this.insertIntoTinyMCE(char);
            }
        }
        else if (value == 19) {
            insertString = "ceiling(x)"

            for (let char of insertString) {
                this.insertIntoTinyMCE(char);
            }
        }
        else if (value == 20) {
            insertString = "TOT"

            for (let char of insertString) {
                this.insertIntoTinyMCE(char);
            }
        }
        else if (value == 21) {
            insertString = "PREV"

            for (let char of insertString) {
                this.insertIntoTinyMCE(char);
            }
        }
        else if (value == 22) {
            insertString = "{NUMDAYS}"

            for (let char of insertString) {
                this.insertIntoTinyMCE(char);
            }
        }
        else if (value == 23) {
            insertString = "#[m1] + #[m2]";

            for (let char of insertString) {
                this.insertIntoTinyMCE(char);
            }
        }
        else if (value == 24) {
            insertString = "#[m1] + #[m2] + #[m3]";

            for (let char of insertString) {
                this.insertIntoTinyMCE(char);
            }
        }
        else if (value == 25) {
            insertString = "(#[m1] + #[m2]) / #[m3]";

            for (let char of insertString) {
                this.insertIntoTinyMCE(char);
            }
        }
        else if (value == 26) {
            insertString = "(#[m1] + #[m2]) * #[m3]";

            for (let char of insertString) {
                this.insertIntoTinyMCE(char);
            }
        }
        else if (value == 27) {
            insertString = "(#[m1] + #[m2]) * n";

            for (let char of insertString) {
                this.insertIntoTinyMCE(char);
            }
        }
        else if (value == 28) {
            insertString = "#[m1] / #[m2]";

            for (let char of insertString) {
                this.insertIntoTinyMCE(char);
            }
        }
        else if (value == 29) {
            insertString = "#[m1] / (#[m1] + #[m3])";

            for (let char of insertString) {
                this.insertIntoTinyMCE(char);
            }
        }
        else if (value == 30) {
            insertString = "#[m1] * #[m2]";

            for (let char of insertString) {
                this.insertIntoTinyMCE(char);
            }
        }
        else {
            return;
        }
    }

    public async validateFormula() {
        //first I need to grab the calculated formula and then remove all of the styling from it. 
        this.getCalculatedFormula();
        //here check for just a single metric edge case
        //that's if the user does just a single metric with no operators or functions
        //false flag equals return false

        //resetting these back to true before I run the checks
        this.validationFlags.formulaEmpty = true;
        this.validationFlags.formulaInvalid = true;
        this.validationFlags.formulaInvalidMetric = true;
        this.validationFlags.formulaMissingMetric = true;
        this.validationFlags.formulaOperator = true;
        this.validationFlags.formulaSpecialCharacter = true;
        this.validationFlags.rootMetricBeingUsedInFormula = true;
        this.validationFlags.templatePlaceholder = false;

        if (this.selectedMetricRow.CalculatedFormula == "") {
            this.validationFlags.formulaEmpty = false;
        }
        else {
            this.validationFlags.formulaEmpty = true;
        }
        let operatorFuncArray: (string)[] = [
            'abs(', 'sqrt(', 'rem(', 'pow(', 'log(', 'round(', 'truncate(', 'floor(', 'ceiling(',
            "+", "*", "/", ">", "<", "=", "^", ":", "TOT", "PREV", " % ", "#%#", " %#", "#% ", "-",
          ];
          
        let variable = "{NUMDAYS}"
        for (let index = 0; index < this.selectedMetricRow.CalculatedFormula.length; index++) {
            if (this.selectedMetricRow.CalculatedFormula[index] == "{") {
                let variableString = this.selectedMetricRow.CalculatedFormula.slice(index, index + variable.length)

                if (variableString != variable) {
                    this.validationFlags.formulaInvalid = false;
                }
                else {
                    this.validationFlags.formulaInvalid = true;
                }
            }

        }

        //checking for operators between each metric, function, and number
        let regex = /(#\[[\s\S]*?\]\d+#|\d+|abs\([^()]*\)|sqrt\([^()]*\)|rem\([^()]*\)|pow\([^()]*\)|log\([^()]*\)|round\([^()]*\)|truncate\([^()]*\)|floor\([^()]*\)|ceiling\([^()]*\))/g;
        let metrics = this.selectedMetricRow.CalculatedFormula.match(/#\[[\s\S]*?\]/g);
        let nonOperators = this.selectedMetricRow.CalculatedFormula.match(regex);
        let nonMetrics = this.selectedMetricRow.CalculatedFormula.split(/#\[[\s\S]*?\]/g);
        const divisionByZeroPattern = /\/\s*0+\b/;
        let count = metrics ? metrics.length : 0;
        let templates =["#[m1]", "#[m2]", "#[m3]"];
        let operators = ["+", "-", "*", "/", ">", "<", "=", "^", ":", "%"];
        let operatorCount = 0;

        this.validationFlags.formulaMissingMetric = (count >= 1) ? true : false;

        let result: any = await this.manageMetricsService.validateFormula(this.selectedMetricRow.CalculatedFormula);

        this.validationFlags.formulaInvalid = result.formulaInvalid;
        this.validationFlags.formulaInvalidMetric = result.formulaInvalidMetric;
        this.validationFlags.formulaSpecialCharacter = result.formulaSpecialCharacter;

        //check for operators at the beginning and end of the formula
        if (operators.some(op => this.selectedMetricRow.CalculatedFormula.trim().startsWith(op) || this.selectedMetricRow.CalculatedFormula.trim().endsWith(op))) {
            this.validationFlags.formulaInvalid = false;
        }

        if (nonOperators) {
            let position = 0;
            for (let m = 0; m < nonOperators.length; m++) {
                if (templates.includes(nonOperators[m])) {
                    this.validationFlags.formulaInvalid = false;
                    this.validationFlags.templatePlaceholder = true;
                }
                //check for operators between metrics
                if (m + 1 < nonOperators.length) {
                    let currentMetricEnd = this.selectedMetricRow.CalculatedFormula.indexOf(nonOperators[m], position) + nonOperators[m].length;
                    let nextMetricStart = this.selectedMetricRow.CalculatedFormula.indexOf(nonOperators[m + 1], currentMetricEnd);
                    let betweenMetrics = this.selectedMetricRow.CalculatedFormula.substring(currentMetricEnd, nextMetricStart).trim();

                    if (!operators.some(op => betweenMetrics.includes(op))) {
                        this.validationFlags.formulaInvalid = false;
                        break;
                    }
                    position = nextMetricStart;
                }
            }
        }

        //check for operators and functions outside of metric names 
        if (nonMetrics) {
            for (let nonMetric of nonMetrics) {
                if (nonMetric.trim() != "") {
                    for (let operator of operatorFuncArray) {
                        if (nonMetric.includes(operator)) {
                            operatorCount++;
                        }
                    }
                }
            }
        }

        if (operatorCount == 0) {
            this.validationFlags.formulaOperator = false;
        }

        //here i check for any alphabet letters that are not within #[ ] I do have exceptions for the variable and functions 
        //I'm check for this because it should be failing if they are just typing random letters not associated with metrics. 
        if(!(this.checkAlphabetLetters(this.selectedMetricRow.CalculatedFormula))){
            this.validationFlags.formulaInvalid = false;
        }
        if(!this.validationFlags.formulaOperator){
            this.validationFlags.formulaInvalid = true;
        }
        if(!this.validationFlags.formulaMissingMetric){
            this.validationFlags.formulaInvalidMetric = true;
        }
        if(!this.checkMetricIdInCalculatedFormula(this.selectedMetricRow.CalculatedFormula)){
            this.validationFlags.formulaInvalid = false;
            this.validationFlags.rootMetricBeingUsedInFormula = false;
        }

        //check for empty functions
        let emptyFunctions = ["()","( )"];
        for (let func of emptyFunctions) {
            if (this.selectedMetricRow.CalculatedFormula.includes(func)) {
                this.validationFlags.formulaInvalid = false;
            }
        }
        
        if (this.selectedMetricRow.CalculatedFormula.match(divisionByZeroPattern)) {
            this.validationFlags.formulaInvalid = false;
        }

        return;
    }

    public createSelectChange(e: any) {
        if (e.value == 1) {
            this.showCalculated = true;
            this.validationFlags.formulaInvalid = true;
            this.validationFlags.formulaEmpty = true;
            this.selectedMetricRow.Components = [];
            this.selectedMetricRow.QueuedOnImport = false;
            this.validationFlags.formulaInvalidMetric = true;
            this.validationFlags.formulaMissingMetric = true;
            this.validationFlags.formulaOperator = true;
            this.validationFlags.rootMetricBeingUsedInFormula = true;
            this.validationFlags.formulaSpecialCharacter = true;
            this.validationFlags.displayCalculatedErrorMessage = false;
            this.selectedMetricType = e;
            this.selectedMetricRow.Type = MetricTypes.Calculated;
        }
        else {
            let newComponent: MetricComponent = {
                IsCount: this.metricValue == "Count",
                IsTime: this.metricValue == "Time",
                IsPositive: true,
                EndDate: this.selectedEndDate?.name,
                StartDate: this.selectedMetricDate?.name,
                ReportingSetGroup: "",
                ReportingSetName: this.reportingSetCurrent?.name,
                DataValue: this.selectedDataValue?.name,
                FilterFields: [],
                AttributeFields: []
            }
            this.selectedMetricRow.Components = [];
            this.selectedMetricRow.Components.push(newComponent);
            this.selectedMetricRow.CalculatedFormula = undefined;
            this.showCalculated = false;
            this.calculatedMetricHTML = "";
            this.calculatedMetricModel = "";
            this.selectedMetricType = e;

            this.ed = null;
            this.bookmark = null;
            this.bookmarkSpan = "";
            this.bookmarkID = 0;
            this.calculatedMetricHTML = "";
            this.calculatedMetricDiff = "";
            this.calculatedMetricModel = "";
            this.selectedMetricRow.Type = MetricTypes.Standard;

        }
    }

    public async toggleMetricSelector(templateID?: string) {
        this.ngZone.run(() => {
            let metricSelector = this.metricSelectorService.openModalForSingleMetric(MetricSelectorComponent, null);
            this.contextualColor();
            metricSelector?.result?.then(result => {
                this.selectedCalculatedMetric = "";
                let selectedMetricID = result.length > 0 ? parseInt(result[0].MetricID) : 0;

                if (selectedMetricID != 0) {
                    let selectedMetric = this.metricDefinitionsData.find((metric) => metric.MetricID == selectedMetricID);

                    this.selectedCalculatedMetric = "#[" + selectedMetric.MetricName + "]" + selectedMetric.MetricID.toString() + "#";

                    if (templateID) {
                        this.replaceTemplate(templateID);
                    }
                    else {
                        this.insertMetric();
                    }
                }
            });
        });
    }

    public replaceTemplate(templateID: string){
        let templateIndex = this.calculatedMetricHTML.indexOf(templateID);
        //search backwards from templateIndex to find #<
        templateIndex = this.calculatedMetricHTML.lastIndexOf("#<", templateIndex);
        let templateEnd = this.calculatedMetricHTML.indexOf("</span>", this.calculatedMetricHTML.indexOf("]", templateIndex)) + 7;
        let templateSpan = this.calculatedMetricHTML.slice(templateIndex, templateEnd);

        this.calculatedMetricHTML = this.calculatedMetricHTML.replace(this.bookmarkSpan, "");
        this.getTinyBookmark();
        this.calculatedMetricHTML = this.calculatedMetricHTML.replace(templateSpan, this.bookmarkSpan);
        this.ed.setContent(this.calculatedMetricHTML);
        //set cursor location
        this.moveToBookmark();
        this.insertMetric();
        if (this.ed == null) {
            this.ed = tinymce.activeEditor;
        }
        this.ed.fire('blur');
    }

    //This is the function just to insert the string from the function above
    public insertMetric() {
        if (this.ed == null) {
            this.ed = tinymce.activeEditor;
        }

        for (let char of this.selectedCalculatedMetric) {
            this.insertIntoTinyMCE(char);
        }
    }

    //This function is to get rid of the styling from the calculated metric, and get a formula that we can submit 
    public getCalculatedFormula() {
        let removingStyleIndex: number;
        let removingStyles: string = this.calculatedMetricHTML;
        let bracketSpan: string = `<span class="bracketHighlight">`;
        let variableSpan: string = `<span class="variableHighlight">`;
        let metricSpan: string = `<span class="metricHighlight">`;
        let operandSpan: string = `<span class="operandHighlight">`;

        this.spanCounter = 0;
        if(removingStyles.includes("<span")) {
            this.spanCounter++;
        }

        removingStyles = removingStyles.replaceAll(this.bookmarkSpan, "");

        //for loop to remove all of the extra <span tags
        for (let i = 0; i < this.spanCounter; i++) {
            removingStyleIndex = removingStyles.indexOf("<span");
            if (removingStyles.slice(removingStyleIndex, removingStyleIndex + 32) == variableSpan) {
                removingStyles = removingStyles.replace(removingStyles.slice(removingStyleIndex, removingStyleIndex + 32), "");
            }
            else if (removingStyles.slice(removingStyleIndex, removingStyleIndex + 31) == operandSpan) {
                removingStyles = removingStyles.replace(removingStyles.slice(removingStyleIndex, removingStyleIndex + 31), "");
            }
            else if (removingStyles.slice(removingStyleIndex, removingStyleIndex + 31) == bracketSpan) {
                removingStyles = removingStyles.replace(removingStyles.slice(removingStyleIndex, removingStyleIndex + 31), "");
            }
            else if (removingStyles.slice(removingStyleIndex, removingStyleIndex + 30) == metricSpan) {
                removingStyles = removingStyles.replace(removingStyles.slice(removingStyleIndex, removingStyleIndex + 30), "");
            }
            else {
                let end = removingStyles.indexOf('>', removingStyleIndex) + 1;
                removingStyles = removingStyles.replace(removingStyles.slice(removingStyleIndex, end), "");
            }

            removingStyleIndex = removingStyles.indexOf("</span>");
            removingStyles = removingStyles.replace(removingStyles.slice(removingStyleIndex, removingStyleIndex + 7), "");
            

            if (removingStyles.includes("<span")) {
                this.spanCounter++;
            }
        }

        //now i have to remove the outside p tags that are added by tinymce and then it should be just the calculated formula
        this.selectedMetricRow.CalculatedFormula = removingStyles.replace("<p>", "");
        this.selectedMetricRow.CalculatedFormula = this.selectedMetricRow.CalculatedFormula.replace("</p>", "");

        this.selectedMetricRow.CalculatedFormula = this.selectedMetricRow.CalculatedFormula.replace("<strong>", "");
        this.selectedMetricRow.CalculatedFormula = this.selectedMetricRow.CalculatedFormula.replace("</strong>", "");

        //this section is to remove the html character for space aka &nbsp;
        let spaceCounter = 0;
        if (this.selectedMetricRow.CalculatedFormula.includes("&nbsp;")) {
            spaceCounter++;

            //this is the for loop that loops until all the &nbsp; are gone
            //I had to essentiall slice out the &nbsp; and then concat the two strings cause for some reason
            //.replace doesn't recognize &nbsp;, so that's why the code looks a little janky. 
            for (let j = 0; j < spaceCounter; j++) {

                let concat1 = this.selectedMetricRow.CalculatedFormula.slice(0, this.selectedMetricRow.CalculatedFormula.indexOf("&nbsp;"));
                let concat2 = this.selectedMetricRow.CalculatedFormula.slice(this.selectedMetricRow.CalculatedFormula.indexOf("&nbsp;") + 6);

                this.selectedMetricRow.CalculatedFormula = concat1 + " " + concat2;

                if (this.selectedMetricRow.CalculatedFormula.includes("&nbsp;")) {
                    spaceCounter++;
                }
            }
        }
    }

    public async insertIntoTinyMCE(stringToInsert: string) {
        await this.ed.execCommand('mceInsertContent', false, stringToInsert);
        this.typedString += stringToInsert;
        this.onTinyMceChange();
    }

    //gives time for changes to be added to editor before ngmodel functions are called
    public onTinyMceChange() {
        clearTimeout(window["selfmetric"]?.typingTimer);

        window["selfmetric"].typingTimer = setTimeout(() => {
            this.getTinyBookmark()
            let typedString = this.typedString;
            if (typedString.length > 1) {
                let bookmarkIndex = this.ed?.getBody().innerHTML.indexOf(this.bookmarkSpan) - 1;
                this.calculatedMetricHTML = this.ed?.getBody().innerHTML.replace(this.bookmarkSpan, "");
                this.calculatedMetricDiff = this.calculatedMetricHTML.slice(0, bookmarkIndex) + this.bookmarkSpan + this.calculatedMetricHTML.slice(bookmarkIndex + 1);
            }
            this.contextualColor();
            this.triggerCancelConfirm();
            this.typedString = "";
        }, 300);
    }

    //this is the function that checks the tinymce variable to see if there are any metrics in there and then it applies the styling
    public contextualMetrics() {
        let templateCounter = 0;
        //some quality of life variables for the metrics section; 
        let metricStyleSpan = `<span style="color: #278a33;">`;
        let templateStyle = `<span class='clickable' contenteditable='false' style="color: #278a33; cursor: pointer;"`;
        let templates = ["m1", "m2", "m3"];
        
        for (this.contextMetricCounter ; this.contextMetricCounter < this.calculatedMetricHTML.length; this.contextMetricCounter++) {
            
            //first case checks for the opening #[ in a metric and then keeps track of where that index is
            if (this.calculatedMetricHTML[this.contextMetricCounter] == "[" &&
                this.calculatedMetricHTML[this.contextMetricCounter - 1] == "#"
            ) {
                this.contextStartIndex = this.contextMetricCounter + 1;
            }

            //checks for the closing ] and keeps that index
            if (this.calculatedMetricHTML[this.contextMetricCounter] == "]" &&
                this.contextStartIndex != -1
            ) {
                this.contextEndIndex = this.contextMetricCounter;
            }

            if (templates.includes(this.calculatedMetricHTML.slice(this.contextStartIndex, this.contextEndIndex).replace(this.bookmarkSpan, ""))) {
                templateCounter++;
                let templateText = this.calculatedMetricHTML.slice(this.contextStartIndex, this.contextEndIndex);
                let id = templateCounter + "|template";
                let onclickFunc = 'onclick="parent.toggleMetricSelector(\'' + id + '\')"';

                let bookmarkIndex = templateText.indexOf(this.bookmarkSpan);
                if (bookmarkIndex == 0) {
                    templateText = templateText.replace(this.bookmarkSpan, "");
                    this.calculatedMetricHTML = this.calculatedMetricHTML.slice(0, this.contextStartIndex) + this.bookmarkSpan + templateStyle + "id='" + id + "'" + onclickFunc + ">" + templateText + "</span>" + this.calculatedMetricHTML.slice(this.contextEndIndex);
                }
                else{
                    this.calculatedMetricHTML = this.calculatedMetricHTML.slice(0, this.contextStartIndex) + templateStyle + "id='" + id + "'" + onclickFunc + ">" + templateText + "</span>" + this.calculatedMetricHTML.slice(this.contextEndIndex);
                }
                //reset the indexes
                this.contextStartIndex = -1;
                this.contextEndIndex = -1;
            }

            //this section only fires on 3 conditions if there is a start index and end index, and also if the loops character is the closing #
            else if (this.contextStartIndex != -1 && this.contextEndIndex > this.contextStartIndex && (this.calculatedMetricHTML[this.contextMetricCounter] == "#" && this.contextMetricCounter > this.contextEndIndex)) {

                //I need to verify before I style that this is a valid metric so here I do string manipulation to get the metric id and metric name/abbreviation (it takes both of those options)
                let idIndex = this.contextMetricCounter - this.contextEndIndex;
                let id = this.calculatedMetricHTML.slice(this.contextEndIndex + 1, (this.contextEndIndex + 1) + idIndex - 1);
                let operatorStyle = `<span style="color: #e6258d;">`;

                //these if statements are for incase the bookmark breaks up the metric id and name. it happens occasionally
                if (id.includes(this.bookmarkSpan)) {
                    id = id.replace(this.bookmarkSpan, "");
                }

                let name = this.calculatedMetricHTML.slice(this.contextStartIndex, this.contextEndIndex);
                if (name.includes(this.bookmarkSpan)) {
                    name = name.replace(this.bookmarkSpan, "");
                }
                if (name.includes("<span") && !name.includes(this.bookmarkSpan)) {
                    //this is for the metrics that have operators in them I have to remove that styling. like Abandon %

                    name = name.replaceAll(operatorStyle, "");
                    name = name.replaceAll("</span>", "");
                }

                //seperate function to check metrics
                let insert = this.verifyMetric(name, id);

                if (insert) {

                    //here I just do some string manipulation to add the metric styling. I use a lot of seperate variables just to make it a tiny bit more readable
                    let insertString = "";
                    if (this.calculatedMetricHTML.slice(this.contextStartIndex, this.contextEndIndex).includes(operatorStyle)) {
                        insertString = this.calculatedMetricHTML.slice(0, this.contextStartIndex) + metricStyleSpan +
                            (this.calculatedMetricHTML.slice(this.contextStartIndex, this.contextEndIndex).replaceAll(operatorStyle, "").replaceAll("</span>", "")) + "</span>" + this.calculatedMetricHTML.slice(this.contextEndIndex);
                    }
                    else {
                        insertString = this.calculatedMetricHTML.slice(0, this.contextStartIndex) + metricStyleSpan +
                            this.calculatedMetricHTML.slice(this.contextStartIndex, this.contextEndIndex) + "</span>" + this.calculatedMetricHTML.slice(this.contextEndIndex);
                    }

                    this.calculatedMetricHTML = insertString;

                    //attempt to recaluclate the contextMetricCounter, in case the bookmark or inner operator removes changes the endIndex
                    for(let tempIndex = this.contextStartIndex; tempIndex < this.calculatedMetricHTML.length; tempIndex++){
                        if (this.calculatedMetricHTML[tempIndex] == "]" && this.contextStartIndex != -1) {
                            this.contextMetricCounter = tempIndex;
                            break;
                        }
                    }

                    //reset the indexes
                    this.contextStartIndex = -1;
                    this.contextEndIndex = -1;
                }
            }
        }

        //reset the indexes
        this.contextMetricCounter = 0;
        this.contextEndIndex = -1;
        this.contextStartIndex = -1;
    }

    //this is the function that checks for operators in the contextual coloring and then adds the styling
    public contextualOperators() {
        let operatorStyle = `<span style="color: #e6258d;">`;
        let funcStyle = `<span style="color: #85680b;">`;
        let operatorArray = ["+", "-", "*", "/", ">", "<", "=", "%", "^", ":", "TOT", "PREV"];

        //here I have to keep track of the bookmark because it has operators in it like = and <> 
        //these indexes are just so that I can skip the bookmark and not apply styling to the bookmark and break the bookmark
        let bookmarkStart: number = 0;
        let bookmarkEnd: number = 0;

        bookmarkStart = this.calculatedMetricHTML.indexOf(this.bookmarkSpan);
        bookmarkEnd = bookmarkStart + this.bookmarkSpan.length;

        if (bookmarkStart == -1) {
            bookmarkEnd = 0;
        }


        for (this.contextOperatorCounter; this.contextOperatorCounter < this.calculatedMetricHTML.length; this.contextOperatorCounter++) {
            //here is some variables to check for TOT and PREV
            let totCheck = this.calculatedMetricHTML.slice(this.contextOperatorCounter, this.contextOperatorCounter + 3);
            let prevCheck = this.calculatedMetricHTML.slice(this.contextOperatorCounter, this.contextOperatorCounter + 4);

            //check for single character operators
            if (operatorArray.includes(this.calculatedMetricHTML[this.contextOperatorCounter]) && (this.contextOperatorCounter < bookmarkStart || this.contextOperatorCounter >= bookmarkEnd)
            ) {

                let insert = this.calculatedMetricHTML.slice(0, this.contextOperatorCounter) + operatorStyle + this.calculatedMetricHTML[this.contextOperatorCounter] + "</span>" + this.calculatedMetricHTML.slice(this.contextOperatorCounter + 1);

                this.calculatedMetricHTML = insert;
                //it will loop forever if I don't add to the counter, and luckily the spans for styling are the same length everytime so I can hard code that
                this.contextOperatorCounter += 37;

                //after i add the styling you have to update the bookmark indexes
                bookmarkStart = this.calculatedMetricHTML.indexOf(this.bookmarkSpan);
                bookmarkEnd = bookmarkStart + this.bookmarkSpan.length;
            }

            //check for TOT
            if (operatorArray.includes(totCheck) && (this.contextOperatorCounter >= 0 && this.contextOperatorCounter < this.calculatedMetricHTML.length - 2)) {

                let insert = this.calculatedMetricHTML.slice(0, this.contextOperatorCounter) + funcStyle + this.calculatedMetricHTML.slice(this.contextOperatorCounter, this.contextOperatorCounter + 3) + "</span>" + this.calculatedMetricHTML.slice(this.contextOperatorCounter + 3);

                this.calculatedMetricHTML = insert;
                this.contextOperatorCounter += 40;
                bookmarkStart = this.calculatedMetricHTML.indexOf(this.bookmarkSpan);
                bookmarkEnd = bookmarkStart + this.bookmarkSpan.length;
            }

            //check for PREV
            if (operatorArray.includes(prevCheck) && (this.contextOperatorCounter >= 0 && this.contextOperatorCounter < this.calculatedMetricHTML.length - 3)) {

                let insert = this.calculatedMetricHTML.slice(0, this.contextOperatorCounter) + funcStyle + this.calculatedMetricHTML.slice(this.contextOperatorCounter, this.contextOperatorCounter + 4) + "</span>" + this.calculatedMetricHTML.slice(this.contextOperatorCounter + 4);

                this.calculatedMetricHTML = insert;
                this.contextOperatorCounter += 41;
                bookmarkStart = this.calculatedMetricHTML.indexOf(this.bookmarkSpan);
                bookmarkEnd = bookmarkStart + this.bookmarkSpan.length;
            }
        }

        //reset the counter variable
        this.contextOperatorCounter = 0;
    }

    //This is the function that checks for functions and applies styling. 
    //a bit more complex then the other contextual functions above this one
    public contextualFunc() {
        //this holder array is very important, becuase I use it as a stack FIFO style. That way I can match opening and closing paren correctly
        let holder: bracketPair[] = [];
        let openBrackets = ['abs(', 'sqrt(', 'rem(', 'pow(', 'log(', 'round(', 'truncate(', 'floor(', 'ceiling(', '(', '[']
        let closedBrackets = [')', ')', ')', ')', ')', ')', ')', ')', ')', ']']
        for (let i = 0; i < this.calculatedMetricHTML.length; i++) {

            //these functions are for all the different lengths of functions 
            let func3slice = this.calculatedMetricHTML.slice(i - 3, i + 1);
            let func4slice = this.calculatedMetricHTML.slice(i - 4, i + 1);
            let func5slice = this.calculatedMetricHTML.slice(i - 5, i + 1);
            let func7slice = this.calculatedMetricHTML.slice(i - 7, i + 1);
            let func8slice = this.calculatedMetricHTML.slice(i - 8, i + 1);
            
            //escape the onclick function for templates
            let onclickFunc = func8slice == "Selector(" || func8slice == "emplate')";
            //quality of life variables because the string manipulation gets weird later
            let funcStyle = `<span style="color: #85680b;">`;
            let operatorStyle = `<span style="color: #e6258d;">`;
            let bracketStyle = `<span style="color: #79797a;">`;
            let closeTag = "</span>"

            //checks for the opening brackets of all the functions if it finds it then it adds it to the stack array holder
            if ((openBrackets.includes(func3slice) ||
                openBrackets.includes(func4slice) ||
                openBrackets.includes(func5slice) ||
                openBrackets.includes(func7slice) ||
                openBrackets.includes(func8slice) ||
                openBrackets.includes(this.calculatedMetricHTML.slice(i, i + 1))) &&
                this.calculatedMetricHTML.slice(i + 1, i + 8) != closeTag
                && !onclickFunc
            ) {

                if (openBrackets.includes(func3slice)) {
                    holder.push({ bracket: func3slice, index: i - 3 });
                }
                else if (openBrackets.includes(func4slice)) {
                    holder.push({ bracket: func4slice, index: i - 4 });
                }
                else if (openBrackets.includes(func5slice)) {
                    holder.push({ bracket: func5slice, index: i - 5 });
                }
                else if (openBrackets.includes(func7slice)) {
                    holder.push({ bracket: func7slice, index: i - 7 });
                }
                else if (openBrackets.includes(func8slice)) {
                    holder.push({ bracket: func8slice, index: i - 8 });
                }
                //this one is just for operator parenthesis
                else if (openBrackets.includes(this.calculatedMetricHTML.slice(i, i + 1))) {
                    holder.push({ bracket: this.calculatedMetricHTML.slice(i, i + 1), index: i });
                }
            }
            //now this section is just for once a closing bracket is found which in this case is just ) and }
            else if (closedBrackets.includes(this.calculatedMetricHTML[i]) && this.calculatedMetricHTML.slice(i + 1, i + 8) != closeTag && !onclickFunc) {

                //here it just checking to see how long the opening bracket is just because the string manipulation has to be different depending on how long the opening bracket is
                let funcLength = holder[holder.length - 1]?.bracket.length;
                let insert: string;
                if (funcLength == 4) {
                    insert = this.calculatedMetricHTML.slice(0, holder[holder.length - 1].index) +
                        funcStyle + this.calculatedMetricHTML.slice(holder[holder.length - 1].index, holder[holder.length - 1].index + 4) +
                        closeTag + this.calculatedMetricHTML.slice(holder[holder.length - 1].index + 4, i) + funcStyle +
                        this.calculatedMetricHTML.slice(i, i + 1) + closeTag + this.calculatedMetricHTML.slice(i + 1);

                    this.calculatedMetricHTML = insert;
                    i += funcStyle.length + closeTag.length;
                }
                else if (funcLength == 5) {
                    insert = this.calculatedMetricHTML.slice(0, holder[holder.length - 1].index) +
                        funcStyle + this.calculatedMetricHTML.slice(holder[holder.length - 1].index, holder[holder.length - 1].index + 5) +
                        closeTag + this.calculatedMetricHTML.slice(holder[holder.length - 1].index + 5, i) + funcStyle +
                        this.calculatedMetricHTML.slice(i, i + 1) + closeTag + this.calculatedMetricHTML.slice(i + 1);

                    this.calculatedMetricHTML = insert;
                    i += funcStyle.length + closeTag.length;
                }
                else if (funcLength == 6) {
                    insert = this.calculatedMetricHTML.slice(0, holder[holder.length - 1].index) +
                        funcStyle + this.calculatedMetricHTML.slice(holder[holder.length - 1].index, holder[holder.length - 1].index + 6) +
                        closeTag + this.calculatedMetricHTML.slice(holder[holder.length - 1].index + 6, i) + funcStyle +
                        this.calculatedMetricHTML.slice(i, i + 1) + closeTag + this.calculatedMetricHTML.slice(i + 1);

                    this.calculatedMetricHTML = insert;
                    i += funcStyle.length + closeTag.length;
                }
                else if (funcLength == 8) {
                    insert = this.calculatedMetricHTML.slice(0, holder[holder.length - 1].index) +
                        funcStyle + this.calculatedMetricHTML.slice(holder[holder.length - 1].index, holder[holder.length - 1].index + 8) +
                        closeTag + this.calculatedMetricHTML.slice(holder[holder.length - 1].index + 8, i) + funcStyle +
                        this.calculatedMetricHTML.slice(i, i + 1) + closeTag + this.calculatedMetricHTML.slice(i + 1);

                    this.calculatedMetricHTML = insert;
                    i += funcStyle.length + closeTag.length;
                }
                else if (funcLength == 9) {
                    insert = this.calculatedMetricHTML.slice(0, holder[holder.length - 1].index) +
                        funcStyle + this.calculatedMetricHTML.slice(holder[holder.length - 1].index, holder[holder.length - 1].index + 9) +
                        closeTag + this.calculatedMetricHTML.slice(holder[holder.length - 1].index + 9, i) + funcStyle +
                        this.calculatedMetricHTML.slice(i, i + 1) + closeTag + this.calculatedMetricHTML.slice(i + 1);

                    this.calculatedMetricHTML = insert;
                    i += funcStyle.length + closeTag.length;
                }
                else if (funcLength == 1) {
                    if (holder[holder.length - 1].bracket == "(") {
                        insert = this.calculatedMetricHTML.slice(0, holder[holder.length - 1].index) +
                            operatorStyle + this.calculatedMetricHTML.slice(holder[holder.length - 1].index, holder[holder.length - 1].index + 1) +
                            closeTag + this.calculatedMetricHTML.slice(holder[holder.length - 1].index + 1, i) + operatorStyle +
                            this.calculatedMetricHTML.slice(i, i + 1) + closeTag + this.calculatedMetricHTML.slice(i + 1);

                        this.calculatedMetricHTML = insert;
                        i += operatorStyle.length + closeTag.length;
                    }
                    else {
                        insert = this.calculatedMetricHTML.slice(0, holder[holder.length - 1].index) +
                            bracketStyle + this.calculatedMetricHTML.slice(holder[holder.length - 1].index, holder[holder.length - 1].index + 1) + closeTag +
                            this.calculatedMetricHTML.slice(holder[holder.length - 1].index + 1, i) + bracketStyle +
                            this.calculatedMetricHTML.slice(i, i + 1) + closeTag + this.calculatedMetricHTML.slice(i + 1);

                        this.calculatedMetricHTML = insert;
                        i += bracketStyle.length + closeTag.length;
                    }
                }

                //after it has found the one pair of opening and closing bracket then I remove that opening bracket from the holder array
                holder.splice(-1, 1) // if so, remove it
            }
        }
    }

    //this function takes a metric name/abbreviation and id, and then makes sure it is a valid metric and returns boolean depending. 
    public verifyMetric(name: string, id: string): boolean {
        //this.metricDefintionsData

        for (let metric of this.metricDefinitionsData) {
            if (metric.MetricID == +id && (metric.Abreviation == name || metric.MetricName == name)) {
                return true;
            }
        }

        return false;
    }

    public removeStyling(formula: string) {
        //for loop to remove all of the extra <span tags
        for (let i = 0; i < formula.length; i++) {
            let index = formula.slice(i, i + 5);
            let indexClose = formula.slice(i, i + 6)

            if (index == "<span" && formula.slice(i, i + (this.bookmarkSpan.length)) !== this.bookmarkSpan) {
                let end = formula.indexOf(">", i) + 1;
                formula = formula.slice(0, i) + formula.slice(end);
                i--;
            }

            //I have to do - 7 for the ending span tag
            if (indexClose == "</span" && formula.slice(i - (this.bookmarkSpan.length - 7), i) !== (this.bookmarkSpan.slice(0, this.bookmarkSpan.length - 7))) {
                formula = formula.slice(0, i) + formula.slice(i + 7);
                i--;
            }

        }

        //now i have to remove the outside p tags that are added by tinymce and then it should be just the calculated formula
        formula = formula.replace("<p>", "");
        formula = formula.replace("</p>", "");

        formula = formula.replace("<strong>", "");
        formula = formula.replace("</strong>", "");

        return formula;
    }

    public getTinyBookmark() {
        if(this.ed == null || this.ed.selection == null)
            return;

        this.bookmark = this.ed.selection.getBookmark();

        //create the bookmark and then evertime that it is called I need to add one to the bookmark counter
        //because for some reason you can't edit the bookmark in the typescript at all
        this.bookmarkID = +this.bookmark?.id?.slice(4);
        this.bookmarkSpan = `<span data-mce-type="bookmark" id="mce_` + this.bookmarkID + `_start" data-mce-style="overflow:hidden;line-height:0px" style="overflow: hidden; line-height: 0px;"></span>`;
    }

    public moveToBookmark() {
        if(this.ed == null || this.ed.selection == null)
            return;

        this.ed.selection.moveToBookmark(this.bookmark);
    }

    //This is the main function that handles all of the contextual colors. Set some variables but mostly call other functions to handle the string manipulation
    public contextualColor() {

        //here just checking if the tinymce global variable is set. If it's not then set it to the tinymce active editor
        if (this.ed == null) {
            this.ed = tinymce.activeEditor;
        }

        //here I set the validation flags back to true
        this.validationFlags.formulaEmpty = true;
        this.validationFlags.formulaInvalid = true;
        this.validationFlags.formulaInvalidMetric = true;
        this.validationFlags.formulaMissingMetric = true;
        this.validationFlags.formulaOperator = true;
        this.validationFlags.formulaSpecialCharacter = true;
        this.validationFlags.rootMetricBeingUsedInFormula = true;
        this.validationFlags.templatePlaceholder = false;


        if(this.formulaIsValid){
            this.formulaIsValid = false;
        }
        this.calculatedMetricModel = this.calculatedMetricModel.replace(/<p>\s*<\/p>/g, "");

        //here I have to set the HTML variable differently depending on if it's the first time editing or any other time
        if (this.firstCalculatedEdit) {
            this.calculatedMetricHTML = this.firstCalculatedEditString;
        }
        else{
            if(this.calculatedMetricModel == "<p>&nbsp;</p>\n<p>&nbsp;</p>"){
                this.clearContent();
                return;
            }
            else{
                this.calculatedMetricHTML = this.calculatedMetricModel;
            }
        }

        //There's a bit of a bug with tinymce.getBookmark() where it loads in multiple bookmark spans. So I had to make a for loop to remove the 
        //multiple bookmark spans
        let tempDiff = this.calculatedMetricDiff;
        if (this.bookmarkSpan != "") {
            let tempBookmarkRemovalCounter = 1;

            for (let i = 0; i < tempBookmarkRemovalCounter; i++) {
                tempDiff = tempDiff.replace(this.bookmarkSpan, "");

                if (tempDiff.includes(this.bookmarkSpan)) { tempBookmarkRemovalCounter++; }
            }
        }

        this.calculatedMetricHTML = this.calculatedMetricHTML.replaceAll("&amp;", "&");
        let oldBookmark = "";
        if (!(this.calculatedMetricHTML.replaceAll("&nbsp;", " ") == tempDiff.replaceAll("&nbsp;", " "))) {
            if (this.firstCalculatedEdit) {
                //This is the code to run if it is the first time editing and I'm trying to load in the previous calculated metric
                //I wish I could simply just copy it in but that's not how it works
                //So this code simply sets up the calculatedMetricHTML with the whole previous calculated Metric inserts the bookmark at the end
                //calls the regularly scheduled functions and then set's the content. and returns. 
                this.calculatedMetricHTML = this.firstCalculatedEditString;

                this.getTinyBookmark();

                this.calculatedMetricHTML += this.bookmarkSpan;

                this.calculatedMetricHTML = this.removeStyling(this.calculatedMetricHTML);

                this.contextualOperators();

                //check for metrics
                this.contextualMetrics();

                //check for functions
                this.contextualFunc();

                this.contextualVar();

                this.calculatedMetricHTML = "<p><strong>" + this.calculatedMetricHTML + "</strong></p>";
                this.calculatedMetricDiff = this.calculatedMetricHTML;

                this.ed.setContent(this.calculatedMetricHTML);

                this.firstCalculatedEdit = false;

                this.firstCalculatedEditString = "";

                this.moveToBookmark();

                return;
            }
            else {
                //I'm making this tempdiff and an old bookmark because the way that tinymce fires the ngmodelchange is on typing and when you click on it and focus it. So half the time this is called there
                //is no change and in that case I need to preserve the oldbookmark spot or I start to get bookmark bugs. 
                this.getTinyBookmark();
                oldBookmark = `<span data-mce-type="bookmark" id="mce_` + (this.bookmarkID - 1) + `_start" data-mce-style="overflow:hidden;line-height:0px" style="overflow: hidden; line-height: 0px;"></span>`;
            }

            //here I set calculatedmetricHTML which is the main variable that will contain all the contextual colors changes. I'm not editing the actual model for every step because that also causes bugs
            this.calculatedMetricHTML = this.replaceEntities(this.calculatedMetricHTML);

            //another for loop to remove multiple bookmarks
            let diffBookmarkRemovalCounter = 1;
            for (let i = 0; i < diffBookmarkRemovalCounter; i++) {
                this.calculatedMetricDiff = this.calculatedMetricDiff.replace(oldBookmark, "");

                if (this.calculatedMetricDiff.includes(oldBookmark)) { diffBookmarkRemovalCounter++; }
            }

            //How the code works from this point is that it removes all the styling span tags and then it adds it one by one. operators first, metrics, and then functions
            //after all that is done it then puts that new string into tinymce
            this.calculatedMetricDiff = this.removeStyling(this.calculatedMetricDiff);
            this.calculatedMetricHTML = this.removeStyling(this.calculatedMetricHTML);

            //the logic is different depending on if the user is backspacing or adding a new character
            if (this.calculatedMetricHTML.length < this.calculatedMetricDiff.length) {
                //the model variable is shorter so the user is backspacing here
                this.getDifference(this.calculatedMetricHTML, this.calculatedMetricDiff);
            }
            else {
                //new character is inserted here. 
                this.getDifference(this.calculatedMetricDiff, this.calculatedMetricHTML);
            }

            //this checks for any operators and then applies the correct styling
            this.contextualOperators();

            //check for metrics
            this.contextualMetrics();

            //check for functions/variables
            this.contextualFunc();

            this.contextualVar();

            //this is a check for an empty formula 
            if(this.calculatedMetricModel == ""){
                //this.calculatedMetricHTML = "<p>" + this.bookmarkSpan + "<p>";
            }
            else{
                //add the p tags
                this.calculatedMetricHTML = "<p><strong>" + this.calculatedMetricHTML + "</strong></p>";
            }

            this.calculatedMetricDiff = this.calculatedMetricHTML;
            this.ed.setContent(this.calculatedMetricHTML);
            this.moveToBookmark();
            this.cdr.detectChanges();

            this.editorPasteFlag = false;
            this.editorPasteLength = 0;
        }
        else {
            //here I need to add the new bookmark instead of the old one to the calculatedMetricHTML
            //this.calculatedMetricHTML = this.calculatedMetricDiff.replace(oldBookmark, this.bookmarkSpan);
            this.calculatedMetricDiff = this.calculatedMetricHTML;
        }
    }

    public contextualColorPrePaste(editor:any, args:any){
        if(window["selfmetric"] != null){
            let content = window["selfmetric"].removeStyling(args.content).replace(/\s{2,}/g, ' ');

            window["selfmetric"].editorPasteFlag = true;
            window["selfmetric"].editorPasteLength = content.length; //add logic to actually clean and count
        }
    }

    public setUpTinyMCE(editor:any) {
        let isKeydownRunning = false;
        editor.on('keydown', function (e) {
            if (e.keyCode === 13) { //Enter key
                e.preventDefault();
            }
            if (e.keyCode === 8) { //delete key
                isKeydownRunning = true;
                clearTimeout(window["selfmetric"].typingTimer);

                window["selfmetric"].typingTimer = setTimeout(() => {
                    window["selfmetric"].contextualColor();
                    window["selfmetric"].triggerCancelConfirm();
                    isKeydownRunning = false;
                }, 500);
            }
        });
        editor.on('keypress', function (e) {
            window["selfmetric"].typedString += e.key;
            clearTimeout(window["selfmetric"].typingTimer);
            // waits for user to stop tying and then calls the contextual color function
            window["selfmetric"].typingTimer = setTimeout(() => {
                if (isKeydownRunning) {
                    isKeydownRunning = false;
                    return;
                }
                window["selfmetric"].getTinyBookmark()
                let typedString = window["selfmetric"].typedString;
                if (typedString.length > 1) {
                    let bookmarkIndex = window["selfmetric"].ed.getBody().innerHTML.indexOf(window["selfmetric"].bookmarkSpan) - 1;
                    window["selfmetric"].calculatedMetricHTML = window["selfmetric"].ed.getBody().innerHTML.replace(window["selfmetric"].bookmarkSpan, "");
                    window["selfmetric"].calculatedMetricDiff = window["selfmetric"].calculatedMetricHTML.slice(0, bookmarkIndex) + window["selfmetric"].bookmarkSpan + window["selfmetric"].calculatedMetricHTML.slice(bookmarkIndex+1);
                }
                window["selfmetric"].contextualColor();
                window["selfmetric"].triggerCancelConfirm();
                window["selfmetric"].typedString = "";
            }, 500);
        });
        editor.on('beforeExecCommand', function (e) {
            if (e.command === 'mceInsertNewLine' || e.command === 'InsertParagraph') {
                e.preventDefault();
            }
        });
        editor.on('init', function (e) {
            window["selfmetric"].contextualColor();
        });
    }

    //function that takes two strings from the contextualColors function and then finds the first different character in the strings and then inserts a bookmark at that position into the calculatedMetricHTML
    public getDifference = (s, t) => {
        for(let i = 0; i < t.length; i++){
            if(t[i] !== s[i] && !((t[i] === " " && s[i] === String.fromCharCode(160)) || (t[i] === String.fromCharCode(160) && s[i] === " "))){
                
                if((t[i] == " " || t[i] === String.fromCharCode(160)) && (t[i - 1] == " " || t[i - 1] === String.fromCharCode(160))){
                    //this is for when the user inserts two spaces
                    this.calculatedMetricHTML = this.calculatedMetricDiff.slice(0, i) + this.bookmarkSpan + this.calculatedMetricDiff.slice(i);
                    return;
                }

                //this is just to make sure that it doesn't insert it behind the closing </p> tag
                else if(this.calculatedMetricHTML.slice(i+1) == "/p>"){
                    this.calculatedMetricHTML = this.calculatedMetricHTML.slice(0, i) + this.bookmarkSpan + this.calculatedMetricHTML.slice(i);
                    return;
                }
                //this is just to check for spaces and it's so it includes the space and doesn't break it in half
                else if (t[i] == '&') {
                    //here check to see if it is the &nbsp; which I have to include or it will skip spaces
                    if(t.slice(i, i+6) == "&nbsp;"){
                        this.calculatedMetricHTML = this.calculatedMetricHTML.slice(0, i+7) + this.bookmarkSpan + this.calculatedMetricHTML.slice(i+7);
                        return;
                    }
                    else {
                        this.calculatedMetricHTML = this.calculatedMetricHTML.slice(0, i + 1) + this.bookmarkSpan + this.calculatedMetricHTML.slice(i + 1);
                        return;
                    }
                }
                else if (t[i] == "#" && s[i] == "[") {
                    //this is a special case for when inserting a metric in front of a metric
                    this.calculatedMetricHTML = this.calculatedMetricHTML.slice(0, i) + this.bookmarkSpan + this.calculatedMetricHTML.slice(i);
                    return;
                }
                else if (this.editorPasteFlag == true) {
                    this.calculatedMetricHTML = this.calculatedMetricHTML.replace(/\s{2,}/g, ' ');
                    this.calculatedMetricHTML = this.calculatedMetricHTML.slice(0, i + this.editorPasteLength) + this.bookmarkSpan + this.calculatedMetricHTML.slice(i + this.editorPasteLength);
                        return;
                }
                else {
                    if (this.calculatedMetricHTML.length > this.calculatedMetricDiff.length) {
                        this.calculatedMetricHTML = this.calculatedMetricHTML.slice(0, i + 1) + this.bookmarkSpan + this.calculatedMetricHTML.slice(i + 1);
                        return;
                    }
                    else{
                        this.calculatedMetricHTML = this.calculatedMetricHTML.slice(0, i) + this.bookmarkSpan + this.calculatedMetricHTML.slice(i);
                        return;
                    }
                }
            }
        }
        //This is just supposed to default to the end if I reach this point
        if (!this.calculatedMetricHTML.includes(this.bookmarkSpan)) {
            //this.calculatedMetricHTML = this.calculatedMetricHTML.slice(0, this.calculatedMetricHTML.indexOf('</p>') + 1) + this.bookmarkSpan + this.calculatedMetricHTML.slice(this.calculatedMetricHTML.indexOf('</p>') + 1)
            this.calculatedMetricHTML += this.bookmarkSpan;
        }
    }

    //this function is used just to change > and < to the actual characters. tinymce when you insert those characters puts that into the model variable as the html entity
    //so I just use a replace function to change those to the characters. 
    public replaceEntities(formula: string) {
        let entityCount = 1;

        for (let i = 0; i < entityCount; i++) {
            if (formula.includes("&gt;")) {
                formula = formula.replace("&gt;", ">");

                if (formula.includes("&gt;")) {
                    entityCount++;
                }
            }

            if (formula.includes("&lt;")) {
                formula = formula.replace("&lt;", "<");

                if (formula.includes("&lt;")) {
                    entityCount++;
                }
            }
        }

        return formula;
    }

    //This function is to add the styling around the {NUMDAYS} variable
    public contextualVar() {
        let variableStyle = `<span style="color: #7d3bc8;">`;
        let closeTag = "</span>";
        let variable = "{NUMDAYS}";

        //This string is used to figure out the styling and it makes it easier by removing the bookmark
        let HTMLNoBookmark = this.calculatedMetricHTML.replace(this.bookmarkSpan, "");

        //this line counts how many of {NUMDAYS} are in the htmlnobookmark that way I can run my code through a for loop
        let count = (HTMLNoBookmark.match(/{NUMDAYS}/g) || []).length;

        //have to start at the end of the string, hence the decrementing for loop
        for (let i = count; i > 0; i--) {

            let variableStart = this.getPosition(HTMLNoBookmark, variable, i);
            let variableEnd = variableStart + variable.length;
            let surroundingChars = "";

            //if the bookmark is in the variable that means we need to reinsert the bookmark later. So here we get the surrounding characters 
            //of where you would later insert the bookmark
            if (this.calculatedMetricHTML.indexOf(this.bookmarkSpan) > variableStart && this.calculatedMetricHTML.indexOf(this.bookmarkSpan) < variableEnd) {
                surroundingChars = this.calculatedMetricHTML[this.calculatedMetricHTML.indexOf(this.bookmarkSpan) - 1] +
                    this.calculatedMetricHTML[this.calculatedMetricHTML.indexOf(this.bookmarkSpan) + (this.bookmarkSpan.length)];
            }

            let variableIndex = 0;
            if (surroundingChars == "") {
                //this is for if the bookmark is not inside the NUMDAYS variable 
                //it's a simple find the index and then do some string manipulation
                variableIndex = this.getPosition(this.calculatedMetricHTML, variable, i);

                if (variableIndex != -1) {
                    this.calculatedMetricHTML = this.calculatedMetricHTML.slice(0, variableIndex) + variableStyle +
                        this.calculatedMetricHTML.slice(variableIndex, (variableIndex + variable.length)) + closeTag +
                        this.calculatedMetricHTML.slice((variableIndex + variable.length));
                }
            }
            else {
                //this section is for if the bookmark is inside the NUMDAYS variable
                //first insert the styling like normal
                variableIndex = this.getPosition(HTMLNoBookmark, variable, i);
                if (variableIndex != -1) {
                    HTMLNoBookmark = HTMLNoBookmark.slice(0, variableIndex) + variableStyle +
                        HTMLNoBookmark.slice(variableIndex, (variableIndex + variable.length)) + closeTag +
                        HTMLNoBookmark.slice((variableIndex + variable.length));

                    //now re-insert the bookmark using the surroundingChars
                    let insertIndex = (this.getPosition(HTMLNoBookmark, surroundingChars, i) + 1);

                    variableStart = this.getPosition(HTMLNoBookmark, variable, i);
                    variableEnd = variableStart + variable.length;

                    if (insertIndex >= variableStart && insertIndex <= variableEnd) {
                        HTMLNoBookmark = HTMLNoBookmark.slice(0, insertIndex) + this.bookmarkSpan + HTMLNoBookmark.slice(insertIndex);

                        //then set our main variable after the string manipulation is done
                        this.calculatedMetricHTML = HTMLNoBookmark;
                    }
                    else {
                        //this section is for multiple variables and I'm not sure what to do from here
                    }
                }
            }
        }
    }

    //This function returns the index for the instance of the substring in the string
    //so third parameter gets the index of the nth instance of that substring
    public getPosition(string, subString, index) {
        return string.split(subString, index).join(subString).length;
    }

    clearContent() {
        if (this.ed) {
          this.ed.save(); // Save the current content
          let bodyElement = this.ed.getBody(); // Get the body element of the editor
          while (bodyElement.firstChild) {
            bodyElement.removeChild(bodyElement.firstChild); // Remove all child elements
          }
        }
    }

    public countHashOccurrences(input: string): number {
        const matches = input.match(/#/g);
        return matches ? matches.length : 0;
    }

    private checkAlphabetLetters(input: string): boolean {
        let exceptionStrings = ['abs', 'sqrt', 'rem', 'pow', 'log', 'round', 'truncate', 'floor', 'ceiling', 'NUMDAYS', 'TOT', 'PREV'];
        let insideBrackets = false;
    
        for (let i = 0; i < input.length; i++) {
            if (input.substring(i, i + 2) === "#[") {
                insideBrackets = true;
                i++; // Skip the next character ("]")
            } else if (input[i] === "]") {
                insideBrackets = false;
            } else if (!insideBrackets && /[a-zA-Z]/.test(input[i])) {
                let isValidLetter = true;
                for (let exception of exceptionStrings) {
                    let subString = input.substring(i, i + exception.length);
                    if (subString === exception) {
                        isValidLetter = false;
                        i += subString.length;
                        break;
                    }
                }
                if (isValidLetter) {
                    return false;
                }
            }
        }
    
        return true;
    }


    /**
     * this function checks if the formula includes the root metric on calculation or not
     * the logic in this function is inverted, because the function is called in the context of the formula being invalid
     * @param formulaString the calculated formula string for the metric
     * @returns boolean whether the formula includes root metric on calculation or not (falsy if it does)
     */
    private checkMetricIdInCalculatedFormula(formulaString: string): boolean {
        const metricID = this.selectedMetricRow.MetricID;
        if (metricID === 0) { // not editing a metric
            return true;
        }
        const regex = /\](\d+)#/g;
        let match;
        while ((match = regex.exec(formulaString)) !== null) {
            if (Number(match[1]) === metricID) {
                return false; // The number exists between ] and #
            }
        }
        return true;
    }

    public parseCompValue(value: any){
        let trimmedValue = value.toString().trim();
        if(trimmedValue == `"true"` || trimmedValue == `"false"` || trimmedValue == `true` || trimmedValue == `false`){
            let parsedValue = trimmedValue.replaceAll("\"", "");
            return parsedValue == "true" ? this.localization.get("True") : this.localization.get("False")
        } 
        
        return value;
    }

    public deleteFilterField(index: number) {
        this.selectedMetricRow.Components[0].FilterFields.splice(index, 1);
    }

    public ActivatePopover(popover: NgbPopover){
        this.manageMetricsService.popoverObj = popover;
        this.manageMetricsService.popoverObj.open();
    }

    public getEditFilterStyling() {
        return {'color': !this.AddFilterButtonIsValid() || this.selectedMetricRow.Components[0].FilterFields.length == 0 ? 'grey' : 'royalblue'}
    }

    public closePMLicenseModalNewMetric(){
        let modal = document.getElementById("PMLicenseModalNewMetric") as HTMLElement;
        modal.style.display = (modal.style.display === 'block') ? 'none' : 'block';
    }

    public closePMLicenseModalEditMetric(){
        let modal = document.getElementById("PMLicenseModalEditMetric") as HTMLElement;
        modal.style.display = (modal.style.display === 'block') ? 'none' : 'block';
    }

    public localizeLockedMetricDescriptions(){
        for(let i = 0; i < this.metricDefinitionsData.length; i++){
            if(!this.metricDefinitionsData[i].IsEditable){
                let localization;

                if(this.metricDefinitionsData[i].MetricID == 15118 || this.metricDefinitionsData[i].MetricID == 15161 || this.metricDefinitionsData[i].MetricID == 278 ||
                    this.metricDefinitionsData[i].MetricID == 299 ){
                        localization = this.localizationDescriptions.get(this.metricDefinitionsData[i].MetricName + this.metricDefinitionsData[i].MetricID);
                }
                else{
                    localization = this.localizationDescriptions.get(this.metricDefinitionsData[i].MetricName);
                }

                if(localization != null){
                    this.metricDefinitionsData[i].MetricDescription = localization;
                }
            }
        }
    }

    public areMetricsSame(first: MetricDefinition, second: MetricDefinition): boolean {

        if (!first || !second) {
            return false;
        }

        //Compare base object
        if (first.AggregationType != second.AggregationType ||
            JSON.stringify(first.AssignmentIDs.sort((a, b) => a - b)) != JSON.stringify(second.AssignmentIDs.sort((a, b) => a - b)) ||
            first.CalculatedFormula != second.CalculatedFormula ||
            first.Direction != second.Direction ||
            first.EmpLevelMin != second.EmpLevelMin ||
            first.Group != second.Group ||
            first.Level != second.Level ||
            first.MetricDescription != second.MetricDescription ||
            first.MetricName != second.MetricName ||
            first.NumericType != second.NumericType ||
            first.RecLevelMin != second.RecLevelMin ||
            first.Type != second.Type ||
            first.ShowInSelector != second.ShowInSelector) {
            return false;
        }

        if (first.Type == MetricTypes.Standard) {

            //Compare Component
            let fComp = first.Components[0];
            let sComp = second.Components[0];

            if (fComp.DataValue != sComp.DataValue ||
                fComp.StartDate != sComp.StartDate ||
                JSON.stringify(fComp.AttributeFields) != JSON.stringify(sComp.AttributeFields) ||
                fComp.ReportingSetName != sComp.ReportingSetName ||
                fComp.ReportingSetGroup != sComp.ReportingSetGroup ||
                fComp.IsCount != sComp.IsCount ||
                fComp.IsPositive != sComp.IsPositive ||
                fComp.IsTime != sComp.IsTime ||
                fComp.EndDate != sComp.EndDate) {
                return false;
            }

            //Compare Filter Fields
            let fFilter = first.Components[0].FilterFields;
            let sFilter = second.Components[0].FilterFields;

            for (let i = 0; i < fFilter.length; i++) {
                if (JSON.stringify(fFilter[i].CompValues) != JSON.stringify(sFilter[i].CompValues) ||
                    fFilter[i].ComparisonType != sFilter[i].ComparisonType ||
                    fFilter[i].EvalField != sFilter[i].EvalField ||
                    fFilter[i].IsDate != sFilter[i].IsDate ||
                    fFilter[i].Negated != sFilter[i].Negated) {
                    return false;
                }
            }
        }
        return true;
    }

    public async validateBtn(){
        await this.validateFormula();

        if(
            this.validationFlags.formulaInvalid == false || this.validationFlags.formulaEmpty == false || 
            this.validationFlags.formulaInvalidMetric == false || this.validationFlags.formulaMissingMetric == false || 
            this.validationFlags.formulaOperator == false || this.validationFlags.formulaSpecialCharacter == false || 
            this.validationFlags.rootMetricBeingUsedInFormula === false
        ){
            this.formulaIsValid = false;
            return;
        }

        this.formulaIsValid = true;
    }

    public validateEnableBtn(){
        if(
            this.validationFlags.formulaInvalid == false || this.validationFlags.formulaEmpty == false || 
            this.validationFlags.formulaInvalidMetric == false || this.validationFlags.formulaMissingMetric == false || 
            this.validationFlags.formulaOperator == false || this.validationFlags.formulaSpecialCharacter == false ||
            this.validationFlags.rootMetricBeingUsedInFormula === false
        ){
            return true;
        }

        this.getCalculatedFormula();
        if(this.selectedMetricRow.CalculatedFormula == ""){
            return true;
        }

        if(this.selectedMetricRow.CalculatedFormula == this.originalCalculatedFormula && this.selectedMetricRow._id != null){
            return true;
        }

        if(this.formulaIsValid){
            return true;
        }

        return false;
    }

    public getFormulaValidationErrorMessage(){
        let errorMessage = "";
        if(!this.validationFlags.formulaInvalid && !this.validationFlags.templatePlaceholder){
            errorMessage += this.getLocalizationString('Invalid_Formula', 'The formula is not valid');
            if(errorMessage != ""){
                errorMessage += '\n\n';
            }
        }
        if(!this.validationFlags.formulaEmpty){
            errorMessage += this.getLocalizationString('Empty_Formula', 'Please enter a valid formula');
            if(errorMessage != ""){
                errorMessage += '\n\n';
            }
        }
        if(this.validationFlags.templatePlaceholder){
            errorMessage += this.getLocalizationString('Template_Placeholder_Error', 'The formula is not valid. Replace metric templates with valid metrics as the metric name or ID is incorrect');
            if(errorMessage != ""){
                errorMessage += '\n\n';
            }
        }
        if(!this.validationFlags.formulaInvalidMetric){
            errorMessage += this.getLocalizationString('Formula_Metric_Incorrect_Error', 'Metric name or metric ID is incorrect');
            if(errorMessage != ""){
                errorMessage += '\n\n';
            }
        }
        if(!this.validationFlags.formulaMissingMetric){
            errorMessage += this.getLocalizationString('Formula_Metric_Missing_Error', 'No metrics in the formula');
            if(errorMessage != ""){
                errorMessage += '\n\n';
            }
        }
        if(!this.validationFlags.formulaOperator){
            errorMessage += this.getLocalizationString('Formula_Operator_Missing_Error', 'No operator or function in the formula');
            if(errorMessage != ""){
                errorMessage += '\n\n';
            }
        }
        if(!this.validationFlags.formulaSpecialCharacter){
            errorMessage += this.getLocalizationString('Formula_Special_Characters_Error', 'Cannot use `~!@$&?');
            if(errorMessage != ""){
                errorMessage += '\n\n';
            }
        }
        if(!this.validationFlags.rootMetricBeingUsedInFormula) {
            errorMessage += this.getLocalizationString('Root_Metric_Invalid', 'Root metric not allowed in calculation');
            if(errorMessage != ""){
                errorMessage += '\n\n';
            }
        }

        if (errorMessage.endsWith('\n\n')) {
            errorMessage = errorMessage.slice(0, -2);
        }

        return errorMessage;
    }

    ngOnDestroy(): void {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }
}
